import React, { useState, useEffect, useRef } from "react";
import {
    List, Datagrid, TextField, TextInput, PasswordInput, FunctionField, useShowController, useRedirect, SimpleList, Create, SimpleForm, useRefresh, SelectInput, Toolbar as RaToolbar, Button as RaButton, SaveButton, Edit, useInput, EditButton, AutocompleteArrayInput, FormDataConsumer
} from "react-admin";
import {
    useMediaQuery, makeStyles, Slide, AppBar, Toolbar, Typography, Switch, Dialog, DialogContent, DialogActions, Button, IconButton, Checkbox, FormControlLabel, TextField as MuiTextField, DialogTitle, ListSubheader,
    Paper, Table, TableHead, TableBody, TableRow, TableCell, Box, Portal, TableContainer, TableSortLabel, TablePagination, withStyles, ListItem, ListItemIcon, MenuItem, ListItemText, DialogContentText, CircularProgress, Menu, FormControl, InputLabel, Select, InputAdornment, List as MuiList
} from "@material-ui/core";
import { customTheme } from "./customTheme";
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import { translate, crudUpdate, crudDelete } from 'ra-core';
// import DeleteButtonWithConfirmation from "./components/DeleteButtonWithConfirmation";
import moment from "moment";
import CustomDateTimePicker from "./components/CustomDateTimePickerV4";
import config from './config.json';
import Skeleton from '@material-ui/lab/Skeleton';
import { vehicleSvgs, hideMobileNumber, hideName } from "./sharedData";
import RaAutocompleteInput from "./components/RaAutocompleteInput";
import RaGenderInput from "./components/RaGenderInput";
import CustomCreateButton from './components/CustomCreateButton';
import RaGenderField from "./components/RaGenderField";
import RaEditableTextField from "./components/RaEditableTextField";
// import DisplayColumnsButton from './components/DisplayColumnsButton';
import ScrollableTable from './components/ScrollableTable';
import CustomExportButton from './components/CustomExportButton';
import PhoneAndroidIcon from '@material-ui/icons/PhoneAndroid';
import CustomSearch from "./components/CustomSearch";
import CustomFilter from "./components/CustomFilter";
import ParkingSearchSelector from './components/ParkingSearchSelector';
import { useLocation } from 'react-router-dom';
import CustomPagination from './components/CustomPagination';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import SaveIcon from '@material-ui/icons/Save';
import RoomIcon from '@material-ui/icons/Room';
import queryString from 'query-string';
import DateRangeIcon from '@material-ui/icons/DateRange';
import { MuiPickersUtilsProvider, DateTimePicker } from "@material-ui/pickers";
import DateTimePickerToolbar from "./components/DateTimePickerToolbar";
import DateFnsUtils from '@date-io/date-fns';
import PaymentIcon from '@material-ui/icons/Payment';
import { Link } from "react-router-dom";
import { saveTokens } from './utils/saveTokens';
import { MapContainer, TileLayer, Marker, Tooltip } from "react-leaflet"
import CloseIcon from '@material-ui/icons/Close';
import 'leaflet/dist/leaflet.css';
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import notify from './components/CustomUseNotify';
import CustomDeleteButton from './CustomDeleteButton';
import DeleteIcon from '@material-ui/icons/Delete';
import RECAPTCHA from "react-google-recaptcha";
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import { stringify } from 'query-string';
import HistoryIcon from '@material-ui/icons/History';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import EditIcon from '@material-ui/icons/Edit';
import ShowTimePeriod from './components/ShowTimePeriod';

function isJsonString(str) {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
};

const useStyles = makeStyles({
    root: {
        width: '100%',
        maxWidth: 360,
    },
    list: {
        marginBottom: 0,
    },
    parkingSelectorContainer: {
        display: "grid",
        justifyContent: "space-between",
    },
    statusIndicator: {
        display: "inline-block",
        width: 10,
        height: 10,
        borderRadius: 50,
        marginRight: 3
    },
    summaryBox: {
        borderRadius: 10,
        border: "1px solid #bbb",
        padding: "15px 20px",
        flex: 1,
        minWidth: 200,
        maxWidth: 400
    },
    mainTableCell: {
        color: `${customTheme.palette.grey[900]} !important`,
        fontWeight: 500,
    },
    listVehicleIcon: {
        width: 25,
        height: 25,
        marginRight: customTheme.spacing(1),
        verticalAlign: "middle",
    },
    chipCell: {
        textAlign: "center",
        padding: customTheme.spacing(1, 2),
        display: "inline-block",
        borderRadius: 50,
    },
    dialogPaper: {
        borderRadius: 15,
        padding: "5px 15px 15px",
        maxWidth: 350
    },
    dialogButton: {
        borderRadius: 100,
        padding: "8px 25px"
    },
    dialogPaperBig: {
        borderRadius: 15,
        padding: "5px 15px 15px",
        maxWidth: 500
    },
    columnButton: {
        color: customTheme.palette.primary.main,
        WebkitTouchCallout: "none",
        WebkitUserSelect: "none",
        KhtmlUserSelect: "none",
        MozUserSelect: "none",
        msUserSelect: "none",
        userSelect: "none",
        '&:hover': {
            cursor: 'pointer',
        },
        "&:active": {
            opacity: 0.6,
        }
    },
    menuLink: {
        textDecoration: "none",
        color: "#444",
    },
    columnLink: {
        display: 'flex',
        alignItems: 'center',
        '&:hover': {
            cursor: 'pointer',
        }
    },
});

const toolbarStyles = {
    toolbar: {
        display: 'flex',
        justifyContent: 'space-between',
    },
};

// const validateUserEdit = (values) => {
//     const errors = {};
//     if (!values.operator) {
//         errors.operator = ['Operator is required'];
//     }
//     return errors
// };

const OperatorUsersCustomEditFields = (props) => {
    const { input: { value: enabled, onChange: setEnabled } } = useInput({ ...props, id: "enabled", source: "enabled" });

    return <FormControlLabel control={<Checkbox checked={enabled === 1 ? true : false} />} label="Enable" onChange={event => setEnabled(event.target.checked === true ? 1 : 0)} />

}

const optionRenderer = choice => `${choice.name}`;

const CustomEditPasswordField = props => {
    const { input: { value: editPassword, onChange: setEditPassword } } = useInput({ ...props, id: "edit_password", source: "edit_password" });

    return (editPassword ?
        <>
            <div><TextInput {...props} source="new_password" type="password" variant="outlined" /></div>
            <div><TextInput {...props} source="confirm_password" type="password" label="Confirm Password" variant="outlined" /></div>
        </>
        :
        <Button startIcon={<EditIcon />} onClick={() => setEditPassword(true)} style={{ width: 180, marginBottom: 15 }}>Edit Password</Button>
    )
}

export const OperatorUserEdit = (props) => {

    const [devicesAvailable, setDevicesAvailable] = useState(null)

    return <Edit {...props} title="Edit Operator App User" undoable={false}>
    <SimpleForm redirect="list" >

            <div className="grid-250" style={{ marginTop: 8, alignItems: "flex-start" }}>
                <div>
                    <div className="formLabel-regular" style={{ position: "relative", top: 10 }}>Location*</div>
                    <TextInput source="parking_name" label="" variant="outlined" style={{ marginTop: 15, marginBottom: 5 }} disabled={true} />
                </div>
            
        </div>
        <div className="grid-250" style={{ marginTop: 8, alignItems: "flex-start" }}>
        <TextInput source="operator" label="Operator" variant="outlined" />
            <TextInput source="mobile_number" label="Mobile" variant="outlined" />
            <TextInput source="gender" label="Gender" variant="outlined" />
        </div>
       <div className="grid-250" style={{ marginTop: 8, alignItems: "flex-start" }}>
            <div>
                <div className="formLabel-regular" style={{ position: "relative" }}>Add Devices*</div>
                <RaAutocompleteInput multiple={true} source="serial_number" resourceParam="serial_number" resourcePath="operatorDevices" label="" getOptionValue={option => option["id"]} getOptionLabel={getDeviceOptionLabel} useAccessKeyId={true} style={{marginTop:8}} filter = {{unassigned_devices: 1, id: props.id}} />
            </div>

            <div>
               { devicesAvailable && <div className="formLabel-regular" style={{ position: "relative" }}>Remove Devices*</div> }
                <FormDataConsumer>
                {({ formData, ...rest }) => {
                    let result;
                    let devicesObj = formData && formData.devices_obj ? JSON.parse(formData.devices_obj) : ''
                    if (formData && devicesObj) {
                        setDevicesAvailable(formData.devices)
                        result = devicesObj
                    }
                    return (
                        formData && devicesAvailable && devicesObj && <AutocompleteArrayInput label={false} choices={result} source="remove_serial_number" optionText={optionRenderer} options={{ suggestionsContainerProps: { placement: "bottom-start" } }} variant="outlined" />
                    )
                }}
            </FormDataConsumer>
            </div>
            <OperatorUsersCustomEditFields />
       </div>
        <div className="grid-250" style={{ marginTop: 8, alignItems: "flex-start" }}>
        <CustomEditPasswordField />
        </div>
    
       
    </SimpleForm>
</Edit>
}

export function OperatorUsersList(props) {
    const classes = useStyles();
    const location = useLocation();
    const refresh = useRefresh();
    const isSmallDevice = useMediaQuery(theme => customTheme.breakpoints.down("xs"));
    const [showFilter] = useState(sessionStorage.getItem("show_filter") === "1");
    let prevSearch = sessionStorage.getItem(location.pathname) ? JSON.parse(sessionStorage.getItem(location.pathname)) : ""
    const [currentParking, setCurrentParking] = useState(prevSearch.currentParking ? prevSearch.currentParking : {});
    const [viewOnly] = useState(sessionStorage.getItem("view_only") === "1");

    const zoneIds = currentParking.zone_ids ? currentParking.zone_ids.split(",") : null;
    const zoneLabels = currentParking.zones ? currentParking.zones.split(";") : null;
    const finalZones = zoneIds && zoneLabels ? zoneIds.map((id, index) => (
        { id, name: zoneLabels[index] }
    )) : null;
    if (finalZones)
        finalZones.sort((a, b) => (a.name > b.name ? 1 : (a.name < b.name ? -1 : 0)));

    const [search, setSearch] = useState(prevSearch.inputSearch)
    let searchTypeState = ["Name"]
    const [searchTypes, setSearchTypes] = useState(prevSearch.type ? prevSearch.type : "Name");



    const filter = { operator: search ? search : undefined, access_key: currentParking.id, parking_info_id: currentParking.allZones ? currentParking.parking_info_id : undefined };

    const onParkingChange = (parking) => {
        setCurrentParking({ ...parking, allZones: true });
    };

    const onZoneChange = (event) => {
        setCurrentParking({
            ...currentParking,
            id: event.target.value,
            name: zoneLabels[zoneIds.findIndex(id => id === event.target.value)],
            allZones: event.target.value === "All"
        });
    };


    return <div className={classes.list}>
        <div className={classes.parkingSelectorContainer} style={{ gridAutoFlow: isSmallDevice ? "row" : "column", gridTemplateColumns: isSmallDevice ? "100%" : "48% 48%", gridRowGap: isSmallDevice ? 18 : 0, margin: 0 }}>
            {showFilter &&
                <ParkingSearchSelector
                    value={currentParking}
                    onChange={onParkingChange}
                    clearable={true}
                    pathName={location.pathname}
                    routeUrl={"parkings"}
                />
            }
            {currentParking.zone_ids && currentParking.zone_ids.includes(',') &&
                <FormControl variant="outlined" style={{ marginTop: isSmallDevice ? 0 : 10 }}>
                    <InputLabel>Zone Name</InputLabel>
                    <Select
                        value={currentParking.allZones ? "All" : currentParking.id}
                        onChange={onZoneChange}
                        label="Zone Name"
                        variant="outlined"
                    >
                        <MenuItem value="All">All</MenuItem>
                        {finalZones.map((zone, index) => (
                            <MenuItem key={index} value={zone.id}>{zone.name}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
            }
        </div>
        <div className='customStyleForDataSearchDiv'>
            <CustomSearch search={search} setSearch={setSearch} searchTypes={searchTypes} setSearchTypes={setSearchTypes} searchTypeState={searchTypeState} pathName={location.pathname} />
            {!viewOnly && sessionStorage.getItem("role") === 'admin' && <CustomCreateButton label="Create User" basePath={props.basePath} resource={props.resource} />}
        </div>
        <List
            {...props}
            style={{marginTop: 20}}
            title="Operator Users"
            bulkActionButtons={false}
            sort={{ field: "operator", order: "ASC" }}
            exporter={false}
            hasCreate={!viewOnly}
            filter={filter}
            empty={false}
            className="tableWithDeleteButton"
            actions={false}
            pagination={<CustomPagination />}
        >
            {isSmallDevice ?
                <SimpleList
                    leftIcon={record => <RaGenderField record={record} source="gender" />}
                    primaryText={record => record["operator"]}
                    secondaryText={record => (<div>
                        {typeof record["mobile_number"] === "string" && record["mobile_number"] !== "" && <div>Mob No: {hideMobileNumber(record["mobile_number"])}</div>}
                        {/* {typeof record["devices"] === "string" && record["devices"] !== "" && <div>Devices: {record["devices"]}</div>} */}
                        {typeof record["logged_in_device"] === "string" && record["logged_in_device"] !== "" && <div>Active Device ID: {record["logged_in_device"]}</div>}
                        <CustomStatusToggle record={record} label="Status" source="enabled" disabled={viewOnly} />
                        <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
                            <span style={{ color: "#5a5a5a" }}>Devices:</span>
                            <DeviceArrayField source="devices" label="Devices"  {...props} record={record} />
                        </div>
                        {!viewOnly && <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            {sessionStorage.getItem('role') === "admin" && <EditButton {...props} record={record} title="Edit" label={false} />}
                            <CustomDeleteButton {...props} record={record} refresh={refresh} resourcePath={'v3/operator/users'} />
                        </div>}
                    </div>)}
                    onContextMenu={event => event.preventDefault()}
                    linkType={false}
                    rowStyle={() => ({ alignItems: "flex-start", borderBottom: "1px solid #18cc69" })}
                />
                :
                <Datagrid className={!viewOnly && "operatorUserDataGrid"} component={ScrollableTable}>
                    <RaGenderField source="gender" label="" />
                    <CustomStatusToggle label="Status" source="enabled" disabled={viewOnly} />
                    <FunctionField source='operator' label='Name' render={(record) => record && record.operator ? hideName(record.operator) : '-'} />
                    <FunctionField source="mobile_number" label="Mobile" render={record => record && record["mobile_number"] && record["mobile_number"] !== null ? hideMobileNumber(record.mobile_number): "-"} />
                    <DeviceArrayField source="devices" label="Devices" />
                    <TextField source="logged_in_device" label="Active Device ID" />
                    {/* <DeleteButtonWithConfirmation mutationMode="pessimistic" undoable={false} /> */}
                    {!viewOnly && <FunctionField className="ListIconsContainerOperatorUser" render={record => record &&
                        <div className="ListIcons">
                            <DeviceLogoutDialog {...props} source="devices" label="Device Logout" record={record} />

                            <div>
                                {sessionStorage.getItem('role') === "admin" && <EditButton {...props} record={record} title="Edit" label={false} />}
                            </div>
                            <div>
                                <CustomDeleteButton {...props} record={record} refresh={refresh} resourcePath={'v3/operator/users'} />
                            </div>
                        </div>
                    } />}
                </Datagrid>
            }
        </List>
    </div>
}

const DeviceLogoutDialog = ({ record }) => {
    const classes = useStyles();
    //const notify = useNotify();
    const refresh = useRefresh()
    const [open, setOpen] = React.useState(false)
    const [loading, setLoading] = React.useState(false)

    const handleClose = () => {
        setOpen(false)
    }

    const handleClickOpen = () => {
        setOpen(true);
    };

    const deviceLogoutHandler = () => {
        setLoading(true)
        fetch(`${config.HOST_NAME}/crm/v3/operator/device/logout`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ operator_id: record.id }),
        })
            .then(response => {
                saveTokens(response)
                return response.json()
            })
            .then(json => {
                if (json.success) {
                    notify("Successfully Logout", "success");
                    setOpen(false)
                    setLoading(false)
                    refresh()
                } else {
                    notify(json.message, "warning");
                    setLoading(false)
                }
            })
            .catch((error) => {
                console.log(error)
                notify("Something went wrong", "warning");
                setLoading(false)
            });
    }

    return (
        <div>
            {
                record.logged_in_device &&
                <Button style={{ color: customTheme.palette.error.main }} onClick={handleClickOpen}><ExitToAppIcon style={{ fontSize: 18 }} /></Button>
            }
            <Dialog
                open={open}
                onClose={handleClose}
                fullWidth
                classes={{ paper: classes.dialogPaper }}
                BackdropProps={{
                    classes: {
                        root: classes.backDrop
                    }
                }}
            >
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Are you sure you want to <strong>Logout</strong>.
                    </DialogContentText>
                </DialogContent>
                <DialogActions style={{ margin: "16px" }}>
                    <Button onClick={handleClose} color="error" variant='contained' style={{ textTransform: "none", fontSize: 13, fontFamily: "Poppins-Regular", letterSpacing: "0.06em", height: "40px", minWidth: "120px", backgroundColor: "#E7EBF0", color: "#334D6E" }} disableElevation>
                        Cancel
                    </Button>
                    <Button onClick={deviceLogoutHandler} color="contained" variant='contained' style={{ backgroundColor: '#de575e', color: "#FFF", textTransform: "none", fontSize: 13, fontFamily: "Poppins-Regular", letterSpacing: "0.06em", height: "40px", minWidth: "120px", }} autoFocus disableElevation>
                        Logout   {loading && <CircularProgress size="1rem" sx={{ color: "white", marginLeft: "20px" }} thickness={6}></CircularProgress>}
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}



function DeviceArrayField(props) {
    const { record, source } = props;

    const [dialogVisible, setDialogVisible] = React.useState(false);

    const openDialog = () => {
        setDialogVisible(true);
    };

    const closeDialog = () => {
        setDialogVisible(false);
    };

    if (typeof record[source] !== "string")
        return null;

    const devices = record[source].split("|");

    return (
        <div style={{ textAlign: "left", display: "block", alignItems: "center", flex: 1 }}>
            <IconButton style={{ width: 40, height: 40, fontSize: 16, color: customTheme.palette.secondary.main }} onClick={openDialog}>{devices.length}</IconButton>

            <Dialog fullWidth open={dialogVisible} onClose={closeDialog} PaperProps={{ style: { maxWidth: 400 } }}>
                {devices.map(device => (
                    <ListItem>
                        <ListItemIcon><PhoneAndroidIcon /></ListItemIcon>
                        <ListItemText primary={device} />
                    </ListItem>
                ))}
            </Dialog>
        </div>
    );
}
function StatusToggle(props) {
    const { record, source } = props;
    const isSmallDevice = useMediaQuery(theme => theme.breakpoints.down("xs"));

    const [dialogVisible, setDialogVisible] = React.useState(false);

    const openDialog = () => {
        setDialogVisible(true);
    };

    const closeDialog = () => {
        setDialogVisible(false);
    };

    const handleUpdate = (event) => {
        event.preventDefault();
        closeDialog();
        const { dispatchCrudUpdate, resource, basePath } = props;
        const data = {
            ...record,
            enabled: !record[source]
        };
        console.log(resource, record, basePath);
        dispatchCrudUpdate(resource, record.id, data, record, basePath, `/${resource}`);
    };

    return (
        <div style={{ textAlign: "left", display: isSmallDevice ? "flex" : "block", alignItems: "center", flex: 1 }}>
            {isSmallDevice && <Typography style={{ fontSize: 15 }}>Status:</Typography>}
            <AntSwitch color={Boolean(record[source]) ? "primary" : "default"} disabled={props.disabled} checked={Boolean(record[source])} onChange={openDialog} />

            <Dialog fullWidth open={dialogVisible} onClose={closeDialog}>
                <DialogContent>Are you sure you want to {record[source] ? "Deactivate" : "Activate"} this Operator User?</DialogContent>
                <DialogActions>
                    <Button color="default" onClick={closeDialog}>No</Button>
                    <Button color="secondary" onClick={handleUpdate}>Yes</Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}
StatusToggle.defaultProps = {
    redirect: 'list',
    undoable: false
};
const CustomStatusToggle = compose(
    connect(
        null,
        { dispatchCrudUpdate: crudUpdate }
    ),
    translate
)(StatusToggle);

const validateUserCreation = (values) => {
    const errors = {};
    if (!values.access_key_id || values.access_key_id === "") {
        errors.access_key_id = 'Please select a parking';
    }

    if (values.name == null || values.name === "") {
        errors.name = 'Name is Required';
    } else if (values.name.length > 50) {
        errors.name = 'Name too long';
    }

    if (typeof values.mobile_number === "string" && values.mobile_number !== "" && values.mobile_number.search(/^\d{10}$/g) === -1) {
        errors.mobile_number = 'Invalid Mobile Number';
    }

    if (!values.serial_number || values.serial_number === "") {
        errors.serial_number = 'Serial Number is required';
    }
    if (!values.password || values.password === "") {
        errors.password = 'Password is required';
    }
    if (values.confirm_password !== values.password) {
        errors.confirm_password = 'Confirm Password does not match';
    }

    return errors;
};
const getDeviceOptionLabel = option => option["serial_number"] + (typeof option["unique_user_id"] === "string" && option["unique_user_id"] !== "" ? ` - ${option["unique_user_id"]}` : "");
export function OperatorUsersCreate(props) {
    const redirect = useRedirect();
    const onSuccess = () => {
        notify("Element Created", "success")
        redirect(props.basePath)
    }
    const onFailure = (error) => {
        notify(error.message, "warning")
    }
    return (
        <Create {...props} onFailure={onFailure} onSuccess={onSuccess} title="Create RFID Data">
            <SimpleForm validate={validateUserCreation} redirect="list">
                {/* To Disable Autofill */}
                <div style={{ display: "none" }}><input type="text" /><input type="password" /></div>

                <div>
                    <div className="formLabel-regular" style={{ position: "relative", top: 10 }}>Location*</div>
                    <RaAutocompleteInput source="access_key_id" resourceParam="name" resourcePath="uniqueParkingAccessKeys" label="" getOptionValue={option => option["id"]} getOptionLabel={option => option["name"]} style={{ marginTop: 15, marginBottom: 30 }} />
                </div>

                <div className="grid-250">
                    <div style={{ display: "flex", columnGap: 25 }}>
                        <div>
                            <div className="formLabel-regular">Operator Name*</div>
                            <TextInput source="name" label="" variant="outlined" style={{ position: "relative", top: -5 }} />
                        </div>
                        <div>
                            <div className="formLabel-regular">Gender</div>
                            <RaGenderInput source="gender" style={{ position: "relative", top: 3 }} />
                        </div>
                    </div>
                    <div>
                        <div className="formLabel-regular" style={{ position: "relative" }}>Mobile Number</div>
                        <TextInput source="mobile_number" label="" variant="outlined" style={{ position: "relative", top: -5 }} />
                    </div>
                </div>

                <div className="grid-250" style={{ marginTop: 8, alignItems: "flex-start" }}>
                    <div>
                        <div className="formLabel-regular" style={{ position: "relative", top: 2 }}>Devices*</div>
                        <RaAutocompleteInput multiple={true} source="serial_number" resourceParam="serial_number" resourcePath="operatorDevices" label="" getOptionValue={option => option["serial_number"]} getOptionLabel={getDeviceOptionLabel} useAccessKeyId={true} uniqueOptions={option => typeof option["unique_user_id"] === "string" && option["unique_user_id"] !== ""} style={{ minWidth: 280, maxWidth: 500, position: "relative", top: 3, marginBottom: 35 }} filter={{unassigned_devices: 0}}/>
                    </div>
                    <div>
                        <div className="formLabel-regular" style={{ position: "relative", top: 2 }}>Password*</div>
                        <PasswordInput className="password-icon" variant="outlined" label="" source="password" style={{ position: "relative", top: -5 }} />
                    </div>
                    <div>
                        <div className="formLabel-regular" style={{ position: "relative", top: 2 }}>Confirm Password*</div>
                        <PasswordInput className="password-icon" variant="outlined" label="" source="confirm_password" style={{ position: "relative", top: -5 }} />
                    </div>
                </div>
            </SimpleForm>
        </Create>
    );
}

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

/* Operator Devices */
export function OperatorDevicesList(props) {
    const classes = useStyles();
    const location = useLocation();
    const isSmallDevice = useMediaQuery(theme => customTheme.breakpoints.down("xs"));
    const listDataRef = useRef();
    
    const [viewOnly] = useState(sessionStorage.getItem("view_only") === "1");
    const [showFilter] = useState(sessionStorage.getItem("show_filter") === "1");
    const [allowTerminalDeviceChanges] = useState(sessionStorage.getItem("allow_terminal_device_changes") === "1");
    const queryParams = queryString.parse(props.location.search);
    const [prevSearch] = useState(queryParams && queryParams.serial_number ? { inputSearch: queryParams.serial_number, type: "Serial Number" } : sessionStorage.getItem(location.pathname) ? JSON.parse(sessionStorage.getItem(location.pathname)) : "")
    // let prevSearch = sessionStorage.getItem(location.pathname) ? JSON.parse(sessionStorage.getItem(location.pathname)) : ""
    const [currentParking, setCurrentParking] = useState(prevSearch.currentParking ? prevSearch.currentParking : {});
    const finalZones = currentParking.zones_obj ? JSON.parse(currentParking.zones_obj) : []
    if (finalZones)
        finalZones.sort((a, b) => (a.name > b.name ? 1 : (a.name < b.name ? -1 : 0)));

    let searchTypeState = ["Serial Number", "Device Name", "Card Number"]
    const [searchType, setSearchType] = useState(prevSearch.type ? prevSearch.type : "Serial Number");
    const [search, setSearch] = useState(prevSearch.inputSearch)
    const [parkingMenu, setParkingMenu] = useState({});
    const [openMap, setOpenMap] = useState(false);
    const [currentMapCoords, setCurrentMapCoords] = useState(null);
    const [displayModal, setDisplayModal] = useState(false);
    const [data, setData] = useState(null)
    const [use24HourFormat] = useState(sessionStorage.getItem("use_24_hour_format") === "1");
	const [showTimeTillSeconds] = useState(sessionStorage.getItem("show_time_till_seconds") === "1");

	const renderTime = time => {
		const secondsFormat = showTimeTillSeconds ? ":ss" : "";
        if(use24HourFormat) return moment(time, "YYYY-MM-DD HH:mm:ss").format(`DD/MM/YYYY HH:mm${secondsFormat}`)
        return moment(time, "YYYY-MM-DD HH:mm:ss").format(`DD/MM/YYYY hh:mm${secondsFormat} A`)
	};
    const [filterListValue, setFilterListValue] = useState(prevSearch.radioValue ? prevSearch.radioValue : null)
    let filterTypesInitState = [
        {
            filterType: "Terminal",
            dataList: [{ name: "NOT-IN-TERMINAL", id: 1 }],
            listType: "Static",
            caseType: "Static",
            showFilter: true
        }
    ]

    const [settingFilterFormat, setSettingFilterFormat] = useState({})

    const filter = { ...settingFilterFormat, search: { value: search, type: searchType }, access_key: currentParking.id, parking_info_id: currentParking.allZones ? currentParking.parking_info_id : undefined };

    const onParkingChange = (parking) => {
        setCurrentParking({ ...parking, allZones: true });
    };

    const onZoneChange = (event) => {
        setCurrentParking({
            ...currentParking,
            id: event.target.value,
            name: event.target.value === "All" ? 'All' : finalZones.filter((val) => val.id === event.target.value)[0].name,
            allZones: event.target.value === "All"
        });
    };

    const showLocationOnMap = (lat, long, record) => {
        setCurrentMapCoords({
            coordinates: [parseFloat(lat), parseFloat(long)],
            label: record.serial_number,
            parking: record.parking_name
        });
        setOpenMap(true)
    };

    const closeMapHandler = () => {
        setCurrentMapCoords(null);
        setOpenMap(false)
    };

    const getExportFile = (fileType) => {
        const {current : {total, currentSort, filterValues}} = listDataRef
        const params = {
            filter: JSON.stringify({ ...filter, ...filterValues }),
            sort: JSON.stringify([currentSort.field, currentSort.order]),
            page: 1,
            perPage: total,
            user_id: sessionStorage.getItem("user_id")
        };
        fetch(`${config.HOST_NAME}/crm/v3/operator/devices?${queryString.stringify(params)}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
                'Accept': `application/${fileType}`,
            },
        })
            .then(response => {
                saveTokens(response)
                return response.blob()
            })
            .then(blob => {
                const url = URL.createObjectURL(blob);
                const tempLinkElement = document.createElement('a');
                tempLinkElement.href = url;
                tempLinkElement.setAttribute('download', `${currentParking && currentParking.name ? currentParking.name : "Operator Devices"}.${fileType}`);
                tempLinkElement.click();
            })
            .catch(error => {
                notify('Error Exporting Data', 'warning');
            });
    };

    const getExcelFile = () => {
        getExportFile("xlsx");
    };

    const renderLocation = (record) => {
        if (record && record.gps) {
            let coordinates = record.gps.split(",")
            return <Typography variant="body2" color="secondary" className={classes.columnLink} onClick={() => showLocationOnMap(coordinates[0], coordinates[1], record)}>
                <RoomIcon style={{ fontSize: 20, marginRight: 4 }} />
                {`${parseFloat(coordinates[0]).toFixed(6)}, ${parseFloat(coordinates[1]).toFixed(6)}`}
            </Typography>
        }
        return "-"
    }

    const renderStatus = (record) => {
        if (record && record.timestamp) {
            let currentTime = moment().utcOffset("+05:30").format("YYYY-MM-DD HH:mm:ss");
            let end = moment(record.timestamp);
            let duration = moment.duration(end.diff(currentTime));
            let minutes = duration.minutes();
            return minutes >= -3 ? "Online" : `Last Seen at ${record.timestamp}`
        }
        else return "-"
    }

    const openParkingMenu = (event, row) => {
        event.preventDefault();
        setParkingMenu({ mouseX: event.clientX - 2, mouseY: event.clientY - 4, row })
    };

    const closeParkingMenu = () => {
        setParkingMenu({});
    };

    useEffect(() => {
        let values = {}
        // Add more types based on the filters
        if (filterListValue) {
            for (let val in filterListValue) {
                if (filterListValue[val].filterType === "Terminal") {
                    values = { ...values, terminal: filterListValue[val].value ? filterListValue[val].value : undefined }
                }
            }
            setSettingFilterFormat(values)
        }
        if (filterListValue === null) {
            setSettingFilterFormat({})
        }
    }, [filterListValue]) // eslint-disable-line react-hooks/exhaustive-deps

    React.useEffect(() => {
        const queryParams = queryString.parse(props.location.search);
        if (queryParams.parking) {
            let parking = JSON.parse(queryParams.parking)
            var params = { user_id: sessionStorage.getItem("user_id"), filter: JSON.stringify({ general_name: parking.general_name, includeSocieties: true }), page: 1, perPage: 1 }
            fetch(`${config.HOST_NAME}/crm/v3/parkings?${stringify(params)}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                    'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
                },
            })
                .then(response => {
                    saveTokens(response)
                    return response.json()
                })
                .then((responseJson) => {
                    if (responseJson.success) {
                        setCurrentParking(responseJson.data[0])
                    } else notify(responseJson.message, 'warning');
                })
                .catch((e) => {
                    notify('Error fetching Parkings', 'warning')
                });

        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props]);

    return <div className={classes.list}>
        <div className={classes.parkingSelectorContainer} style={{ gridAutoFlow: isSmallDevice ? "row" : "column", gridTemplateColumns: isSmallDevice ? "100%" : "48% 48%", gridRowGap: isSmallDevice ? 18 : 0, margin: isSmallDevice ? "0 16px" : 0 }}>
            {showFilter &&
                <ParkingSearchSelector
                    value={currentParking}
                    onChange={onParkingChange}
                    clearable={true}
                    pathName={location.pathname}
                    routeUrl={"parkings"}
                />
            }
            {currentParking.zone_ids && currentParking.zone_ids.includes(',') &&
                <FormControl variant="outlined" style={{ marginTop: isSmallDevice ? 0 : 10 }}>
                    <InputLabel>Zone Name</InputLabel>
                    <Select
                        value={currentParking.allZones ? "All" : currentParking.id}
                        onChange={onZoneChange}
                        label="Zone Name"
                        variant="outlined"
                    >
                        <MenuItem value="All">All</MenuItem>
                        {finalZones.map((zone, index) => (
                            <MenuItem key={index} value={zone.id}>{zone.name}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
            }
        </div>
        <div className='customStyleForDataSearchDiv'>
            <CustomSearch search={search} setSearch={setSearch} searchTypes={searchType} setSearchTypes={setSearchType} searchTypeState={searchTypeState} pathName={location.pathname} />
            {!viewOnly && sessionStorage.getItem('role') === "admin" && allowTerminalDeviceChanges && <CustomCreateButton label="Create Device" basePath={props.basePath} resource={props.resource} />}
            <CustomFilter filterTypesInitState={filterTypesInitState} filterListValue={filterListValue} setFilterListValue={setFilterListValue} pathName={location.pathname} />
            <CustomExportButton getCSV={getExcelFile} disabled={listDataRef.current && listDataRef.current.total === 0} />
        </div>
        <List
            {...props}
            style={{marginTop: 20}}
            title="Operator Devices"
            bulkActionButtons={false}
            exporter={false}
            filter={filter}
            actions={false}
            empty={false}
            pagination={<CustomPagination setListData={(listData) => {listDataRef.current = listData}} />}
        >
            {isSmallDevice ?
                <SimpleList
                    primaryText={record => record["serial_number"]}
                    secondaryText={record => (<div>
                        {typeof record["unique_user_id"] === "string" && record["unique_user_id"] !== "" && <div>Device Name: {record["unique_user_id"]}</div>}
                        <div>Device Type: {record["device_type"] ? record["device_type"] : "All"}</div>
                        {typeof record["timestamp"] === "string" && record["timestamp"] !== "" && <div>Status: {renderStatus(record)}</div>}
                        {typeof record["battery"] === "string" && record["battery"] !== "" && <div>Battery: {record["battery"]}</div>}
                        {typeof record["power_status"] === "string" && record["power_status"] !== "" && <div>Power Status: {record["power_status"]}</div>}
                        {typeof record["sim"] === "string" && record["sim"] !== "" && record["sim"] !== ",null" && <div>Sim: {record["sim"]}</div>}
                        {typeof record["wifi"] === "string" && record["wifi"] !== "" && <div>Wifi: {record["wifi"]}</div>}
                        {typeof record["app_version"] === "string" && record["app_version"] !== "" && <div>App Version: {record["app_version"]}</div>}
                        {typeof record["model"] === "string" && record["model"] !== "" && <div>Battery: {record["model"]}</div>}
                        {typeof record["gps"] === "string" && record["gps"] !== "" && <div>Coordinates: {record["gps"]}</div>}
                        <FunctionField source='logged_in' label='Logged In' render={record => record && record.logged_in ? <GetLoggedInParking record={record} /> : "-"} />
                        <div
                            className={classes.columnButton}
                            onClick={() => setCurrentParking({ id: record.access_key_id, general_name: record.parking_name, zone_ids: "", zones: "" })}
                            onContextMenu={e => openParkingMenu(e, record)}
                        >
                            {record["parking_name"]}
                        </div>
                        {/* <CustomDeviceInfoField {...props} record={record} renderLocation={renderLocation} /> */}
                        {!viewOnly && <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: 'wrap' }}>
                            {(sessionStorage.getItem('show_device_wallet') === "1" || (sessionStorage.getItem('role') === "admin" && allowTerminalDeviceChanges)) && <WalletAmountDialog source="balance" record={record} label="Wallet Amount" />}
                            {(sessionStorage.getItem('show_device_wallet') === "1" || (sessionStorage.getItem('role') === "admin" && allowTerminalDeviceChanges)) && <RechargeButton label="Recharge" record={record} />}
                            {sessionStorage.getItem('role') === "admin" &&
                                <RaButton title="Last Logins" label={false} onClick={() => {
                                    setData(record)
                                    setDisplayModal(true)
                                }}><HistoryIcon /></RaButton>
                            }
                            {sessionStorage.getItem('role') === "admin" && allowTerminalDeviceChanges && <EditButton {...props} record={record} title="Edit" label={false} />}
                            {sessionStorage.getItem('role') === "admin" && allowTerminalDeviceChanges && <DeleteDeviceButton {...props} record={record} />}
                            {(sessionStorage.getItem('show_device_wallet') === "1" || (sessionStorage.getItem('role') === "admin" && allowTerminalDeviceChanges)) && <AssignCard label="Payment Card" record={record} />}
                        </div>}
                    </div>)}
                    onContextMenu={event => event.preventDefault()}
                    linkType={false}
                    rowStyle={() => ({ alignItems: "flex-start", borderBottom: "1px solid #18cc69" })}
                />
                :
                <Datagrid className={!viewOnly && allowTerminalDeviceChanges ? 'operatorDeviceListDataGrid' : ''} component={ScrollableTable}>
                    <FunctionField source="serial_number" label="Serial Number" render={record => record && record.serial_number ? <Link to={`/getParkingTerminals?${queryString.stringify({ serial_number: record.serial_number })}`} style={{ textDecoration: "none" }}><span style={{ color: "#334d6e", fontWeight: "bold" }}>{record.serial_number}</span></Link> : '-'} />
                    <RaEditableTextField source="unique_user_id" label="Device Name" />
                    <FunctionField label="Parking Name" render={row => (
                        <div
                            className={classes.columnButton}
                            onClick={() => setCurrentParking({ id: row.access_key_id, general_name: row.parking_name, zone_ids: "", zones: "" })}
                            onContextMenu={e => openParkingMenu(e, row)}
                        >
                            {row["parking_name"]}
                        </div>
                    )} />
                    <FunctionField source="device_type" label="Device Type" render={record => record && record.device_type !== '' && record.device_type != null ? record.device_type : 'All'} />

                    <FunctionField source="timestamp" label="Status" render={record => {
                        if (record && record.timestamp) {
                            let currentTime = moment().utcOffset("+05:30").format("YYYY-MM-DD HH:mm:ss");
                            let end = moment(record.timestamp);
                            let duration = moment.duration(end.diff(currentTime));
                            let minutes = duration.minutes();
                            return minutes >= -3 ? "Online" : `Last Seen at ${record.timestamp}`
                        }
                        else return "-"
                    }} />
                    <FunctionField source="power_status" label="Power Status" render={record => record && record.power_status ? record.power_status : '-'} />
                    <FunctionField source="gps" label="Coordinates" render={record => record && record.gps ? renderLocation(record) : '-'} />
                    <FunctionField source="battery" label="Battery" render={record => record && record.battery ? record.battery : '-'} />
                    <FunctionField source="wifi" label="WiFi" render={record => record && record.wifi ? record.wifi : '-'} />
                    <FunctionField source="sim" label="Sim" render={record => record && record.sim && record.sim !== ",null" ? record.sim : '-'} />
                    <FunctionField source="app_version" label="App Version" render={record => record && record.app_version ? record.app_version : '-'} />
                    <FunctionField source="model" label="Model" render={record => record && record.model ? record.model : '-'} />
                    <FunctionField source='logged_in' label='Logged In' render={record => record && record.logged_in ? <GetLoggedInParking record={record} /> : "-"} />
                    <FunctionField source='last_downloaded_at' label="Last Downloaded At" render={record => record && record.last_downloaded_at ? renderTime(record.last_downloaded_at) : "-"} />
                    <FunctionField source='last_entry_uploaded_at' label="Last Uploaded At" render={record => record && record.last_entry_uploaded_at ? (record.last_entry_uploaded_at > record.last_exit_uploaded_at ? renderTime(record.last_entry_uploaded_at) : renderTime(record.last_exit_uploaded_at)) : "-"} />
                    {/* <CustomDeviceInfoField label="Device Info" renderLocation={renderLocation} /> */}
                    {!viewOnly && (sessionStorage.getItem('show_device_wallet') === "1" || (sessionStorage.getItem('role') === "admin" && allowTerminalDeviceChanges)) && <WalletAmountDialog source="balance" label="Wallet Amount" />}
                    {!viewOnly && (sessionStorage.getItem('show_device_wallet') === "1" || (sessionStorage.getItem('role') === "admin" && allowTerminalDeviceChanges)) && <AssignCard label="Payment Card" />}
                    {!viewOnly && allowTerminalDeviceChanges && <FunctionField className="ListIconsContainerOperatorDevices" render={record => record &&
                        <div className="ListIcons">
                            {sessionStorage.getItem('role') === "admin" &&
                                <RaButton title="Last Logins" label={false} onClick={() => {
                                    setData(record)
                                    setDisplayModal(true)
                                }}><HistoryIcon /></RaButton>
                            }
                            <div>
                                {(sessionStorage.getItem('show_device_wallet') === "1" || sessionStorage.getItem('role') === "admin") && <RechargeButton record={record} label="Recharge" />}
                            </div>
                            {
                                sessionStorage.getItem('role') === "admin" &&
                                <div>
                                    <EditButton {...props} record={record} title="Edit" label={false} />
                                </div>
                            }
                            {
                                sessionStorage.getItem('role') === "admin" &&
                                <div>
                                    <DeleteDeviceButton {...props} record={record} />
                                </div>
                            }

                        </div>
                    } />}
                </Datagrid>
            }
        </List>
        <Menu
            anchorReference="anchorPosition"
            anchorPosition={parkingMenu.mouseY !== null && parkingMenu.mouseX !== null ? { top: parkingMenu.mouseY, left: parkingMenu.mouseX } : { top: 0, left: 0 }}
            keepMounted
            open={Boolean(parkingMenu.mouseX)}
            onClose={closeParkingMenu}
        >
            <Link to={`/parkings/${parkingMenu.row ? parkingMenu.row.access_key_id : ""}/show`} className={classes.menuLink}><MenuItem>Summary</MenuItem></Link>
            <Link to={`/parkings/${parkingMenu.row ? parkingMenu.row.access_key_id : ""}`} className={classes.menuLink}><MenuItem>Settings</MenuItem></Link>
        </Menu>

        <Dialog fullScreen open={openMap} onClose={closeMapHandler} TransitionComponent={Transition}>
            <AppBar style={{ position: "relative" }}>
                <Toolbar>
                    <IconButton edge="start" color="inherit" onClick={closeMapHandler} aria-label="close"><CloseIcon /></IconButton>
                    <Typography variant="h6" style={{ marginLeft: 7 }}>{currentMapCoords ? currentMapCoords.parking : ""} Device Location</Typography>
                </Toolbar>
            </AppBar>

            {currentMapCoords &&
                <MapContainer center={currentMapCoords.coordinates} zoom={17} scrollWheelZoom={true} style={{ height: "100%" }}>
                    <TileLayer
                        attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    />
                    <Marker position={currentMapCoords.coordinates}>
                        <Tooltip direction="top" offset={[-15, -15]} opacity={0.8} permanent>{currentMapCoords.label}</Tooltip>
                    </Marker>
                </MapContainer>
            }
        </Dialog>

        {displayModal && <CustomModal displayModal={displayModal} setDisplayModal={setDisplayModal} data={data} />}
    </div >
}

const GetLoggedInParking = ({ record }) => {
    const isSmallDevice = useMediaQuery(theme => customTheme.breakpoints.down("xs"));
    //const notify = useNotify();
    const [loading, setLoading] = useState(true);
    const [parkingInfo, setParkingInfo] = useState({})

    React.useEffect(() => {
        const token = sessionStorage.getItem("token");

        fetch(`${config.HOST_NAME}/crm/v3/getParkingDetailByAccessKey/${record.logged_in}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
        })
            .then(response => response.json())
            .then(json => {
                setLoading(false);
                if (json.success) {
                    setParkingInfo(json.data)
                } else {
                    notify(json.message, 'warning');
                }
            })
            .catch((error) => {
                setLoading(false);
                notify('Error Fetching Parking Info', 'warning');
            });
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    return (<div style={{ display: "block" }}>
        {
            !isSmallDevice ?
                <>
                    {loading ?
                        <div style={{ display: "flex", justifyContent: "space-evenly", alignItems: "center" }}>
                            <Skeleton variant="text" height={15} width={40} style={{ display: "inline-block", transform: "none" }} />
                        </div>
                        :
                        <div style={{ display: "flex", justifyContent: "space-evenly", alignItems: "center" }}>
                            {parkingInfo.name}
                        </div>
                    }
                </>
                : <>
                    {<div><span>Logged In: </span>{loading ? <Skeleton variant="text" height={8} width={8} style={{ display: "inline-block", transform: "none", borderRadius: 20 }} /> : parkingInfo.name}</div>}
                </>
        }
    </div>
    );
};

const WalletAmountDialog = ({ record }) => {
    const classes = useStyles();
    //const notify = useNotify();
    const [open, setOpen] = React.useState(false)
    const [loading, setLoading] = React.useState(false)
    const [startDateTime, setStartDateTime] = React.useState(Date.now());
    const [walletAmount, setWalletAmount] = React.useState("")

    const handleClose = () => {
        setOpen(false)
    }

    const handleClickOpen = () => {
        setOpen(true);
    };

    const walletAmountHandler = () => {
        setLoading(true)
        fetch(`${config.HOST_NAME}/crm/v3/getWalletAmount?start_time=${moment(startDateTime).format("YYYY-MM-DD HH:mm:ss")}&wallet_id=${record.operator_devices_wallet_id}`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
            }
        })
            .then(response => {
                saveTokens(response)
                return response.json()
            })
            .then(json => {
                if (json.success) {
                    console.log(json.data)
                    setWalletAmount(json.data)
                    // notify("Successfully Logout", "success");
                    // setOpen(false)
                    setLoading(false)
                    // refresh()
                } else {
                    notify(json.message, "warning");
                    setLoading(false)
                }
            })
            .catch((error) => {
                console.log(error)
                notify("Something went wrong", "warning");
                setLoading(false)
            });
    }

    React.useEffect(() => {
        walletAmountHandler()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <div>

            <p style={{ display: "inline" }}>₹ {record.balance ? record.balance : 0}</p>
            <IconButton style={{ color: "#18cc69" }} onClick={handleClickOpen}> <DateRangeIcon style={{ fontSize: "22px" }} /></IconButton>
            <Dialog
                open={open}
                onClose={handleClose}
                fullWidth
                classes={{ paper: classes.dialogPaperBig }}
                BackdropProps={{
                    classes: {
                        root: classes.backDrop
                    }
                }}
            >
                <DialogContent>
                    <div style={{ display: "grid", gridTemplateColumns: "60% 40%", justifyContent: "space-around", alignItems: "center", gap: 20 }}>
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <DateTimePicker
                                disableFuture
                                ampm
                                value={startDateTime}
                                onChange={(datetime) => setStartDateTime(datetime)}
                                label="Balance Until"
                                className={classes.timeFilterInput}
                                inputVariant="outlined"
                                TextFieldComponent={(props) => <MuiTextField {...props} size="small" />}
                                ToolbarComponent={DateTimePickerToolbar}
                                format="dd/MM/yyyy hh:mm a"
                            />
                        </MuiPickersUtilsProvider>
                        <Button onClick={walletAmountHandler} color="contained" variant='contained' style={{ backgroundColor: '#18cc69', color: "#FFF", textTransform: "none", fontSize: 13, fontFamily: "Poppins-Regular", letterSpacing: "0.06em", height: "40px", minWidth: "120px", }} autoFocus disableElevation>
                            Calculate   {loading && <CircularProgress size="1rem" sx={{ color: "white", marginLeft: "20px" }} thickness={6}></CircularProgress>}
                        </Button>
                    </div>

                    <div style={{ display: "grid", gridTemplateColumns: "60% 40%", justifyContent: "space-around", alignItems: "center", marginTop: 30 }}>
                        <Typography style={{ fontSize: 20, fontWeight: "bold" }}>Total Amount</Typography><Typography style={{ fontSize: 30, color: "#18cc69", textAlign: "right", fontWeight: "bold" }}>₹ {walletAmount ? walletAmount : 0}</Typography>
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="error" variant='contained' style={{ textTransform: "none", fontSize: 13, fontFamily: "Poppins-Regular", letterSpacing: "0.06em", height: "40px", minWidth: "120px", backgroundColor: "#E7EBF0", color: "#334D6E" }} disableElevation>
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}

function RechargeButton(props) {
    const { record } = props;
    const isSmallDevice = useMediaQuery(theme => theme.breakpoints.down("xs"));
    //const notify = useNotify();
    const refresh = useRefresh();
    const classes = useStyles();

    const [loading, setLoading] = useState(false);
    const [paymentFailedDialog, setPaymentFailedDialog] = useState(null);
    const [paymentMethodDialogVisible, setPaymentMethodDialogVisible] = useState(false);
    const [amount, setAmount] = useState("100");
    const [paymentMethod] = useState("Digital");

    const handleAmountChange = event => {
        if (!isNaN(event.target.value)) {
            setAmount(event.target.value);
        }
    };

    const handleAmountBlur = event => {
        if (event.target.value === "") {
            setAmount("0");
        }
    };

    const updateWalletPaymentStatus = async (transactionId, paymentStatus, remarks) => {
        fetch(`${config.HOST_NAME}/crm/walletTransactions/${transactionId}/status`, {
            method: 'PUT',
            headers: {
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ payment_status: paymentStatus, remarks: remarks, serial_number: record.serial_number, access_key_id: record.access_key_id })
        });
    };

    const closePaymentFailedDialog = () => {
        setPaymentFailedDialog(null);
    };

    const rechargeWallet = async (event) => {
        event.preventDefault();
        if (amount === "" || isNaN(amount) || !(amount >= 0)) {
            return notify("Invalid Amount", "warning");
        }
        if (paymentMethod == null) {
            return notify("Please select a payment method", "warning");
        }

        if (paymentMethod === "Cash") {
            rechargeWalletCash(event);
        } else {
            rechargeWalletDigital(event);
        }
    };

    const rechargeWalletDigital = async (event) => {
        event.preventDefault();
        closePaymentFailedDialog();
        closePaymentModeDialog();

        setLoading(true);
        fetch(`${config.HOST_NAME}/crm/initiateDeviceWalletRecharge`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ serial_number: record.serial_number, access_key_id: record.access_key_id, amount: parseFloat(amount) })
        })
            .then(response => {
                saveTokens(response)
                return response.json()
            })
            .then(json => {
                if (json.success) {
                    const order = json.data.order;
                    var options = {
                        description: 'Wallet Recharge',
                        currency: order.currency,
                        key: config.RAZOR_PAY_KEY_ID,
                        amount: order.amount,
                        name: 'ParkSmart',
                        order_id: order.id,
                        notes: {
                            serial_number: record.serial_number,
                            access_key_id: record.access_key_id,
                            parking_name: record.parking_name,
                        },
                        theme: {
                            color: customTheme.palette.primary.main
                        },
                        modal: {
                            ondismiss: () => {
                                setLoading(false);
                                const description = "Payment is cancelled by user";
                                setPaymentFailedDialog(description);
                                updateWalletPaymentStatus(json.data.transaction_id, "CANCELLED", description);
                            }
                        },
                        handler: checkoutData => {
                            fetch(`${config.HOST_NAME}/crm/verifyDeviceWalletRecharge`, {
                                method: 'POST',
                                headers: {
                                    'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                                    'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
                                    'Content-Type': 'application/json'
                                },
                                body: JSON.stringify({ ...checkoutData, transaction_id: json.data.transaction_id, serial_number: record.serial_number, access_key_id: record.access_key_id }),
                            })
                                .then(response => {
                                    saveTokens(response)
                                    return response.json()
                                })
                                .then(json => {
                                    setLoading(false);
                                    if (json.success) {
                                        notify("Payment Successful", "success");
                                        refresh();
                                    } else {
                                        setPaymentFailedDialog(json.message);
                                    }
                                })
                                .catch((error) => {
                                    setLoading(false);
                                    setPaymentFailedDialog("Could not verify Payment");
                                });
                        },
                    }
                    const razorpay = new window.Razorpay(options);
                    razorpay.on('payment.failed', function ({ error }) {
                        setLoading(false);
                        let description, status;
                        if (isJsonString(error.description)) {
                            const errorObj = JSON.parse(error.description);
                            if (errorObj.error) {
                                description = errorObj.error.description;
                                status = errorObj.error.reason;
                            } else {
                                description = errorObj.description;
                                status = errorObj.reason;
                            }
                        } else {
                            description = error.description;
                        }
                        setPaymentFailedDialog(description);
                        updateWalletPaymentStatus(json.data.transaction_id, status === "payment_cancelled" ? "CANCELLED" : "FAILED", description);
                    });

                    razorpay.open();
                } else {
                    setLoading(false);
                    notify(json.message, "warning");
                }
            })
            .catch((error) => {
                console.log(error);
                setLoading(false);
                notify("Check your internet connection", "warning");
            });
    };

    const rechargeWalletCash = (event) => {
        event.preventDefault();
        closePaymentModeDialog();

        setLoading(true);
        const rfidId = record["id"];
        fetch(`${config.HOST_NAME}/crm/rfidData/${rfidId}/recharge`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ amount: amount })
        })
            .then(response => {
                saveTokens(response)
                return response.json()
            })
            .then(json => {
                setLoading(false);
                if (json.success) {
                    notify(json.message, "success");
                    refresh();
                } else {
                    notify(json.message, "warning");
                }
            })
            .catch((error) => {
                console.log(error);
                setLoading(false);
                notify("Check your internet connection", "warning");
            });
    };

    const openPaymentModeDialog = () => {
        setPaymentMethodDialogVisible(true);
    };

    const closePaymentModeDialog = () => {
        setPaymentMethodDialogVisible(false);
    };

    return (
        <div style={{ display: isSmallDevice ? "flex" : "block", alignItems: "center", flex: 1 }}>
            <RaButton label={false} color="secondary" onClick={openPaymentModeDialog}><PaymentIcon /></RaButton>

            <Portal>
                <Dialog open={paymentMethodDialogVisible} onClose={closePaymentModeDialog} classes={{ paper: classes.dialogPaper }}>
                    <DialogTitle style={{ color: customTheme.palette.secondary.main }}><div style={{ fontSize: 16, textAlign: "center" }}>Recharge</div></DialogTitle>
                    <DialogContent style={{ fontSize: 14, marginTop: 0, marginBottom: 0 }}>
                        <MuiTextField value={amount} onChange={handleAmountChange} onBlur={handleAmountBlur} label="Amount" variant="outlined" size="small" />
                        {/* <RadioGroup row value={paymentMethod} onChange={event => setPaymentMethod(event.target.value)} style={{ columnGap: 15, marginTop: 10 }}>
                            <FormControlLabel className="formLabel-regular" value="Digital" control={<Radio color="primary" />} label="Digital" />
                            <FormControlLabel className="formLabel-regular" value="Cash" control={<Radio color="primary" />} label="Cash" />
                        </RadioGroup> */}
                    </DialogContent>

                    <DialogActions style={{ display: "flex", justifyContent: "space-evenly" }}>
                        <Button className={classes.dialogButton} variant="outlined" color="default" onClick={closePaymentModeDialog}>Cancel</Button>
                        <Button disableElevation className={classes.dialogButton} variant="contained" color="secondary" onClick={rechargeWallet}>Recharge</Button>
                    </DialogActions>
                </Dialog>
            </Portal>

            {loading && <Portal>
                <div style={{ position: "fixed", top: 0, left: 0, width: "100%", height: "100%", backgroundColor: "#0001", zIndex: 9999, display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <CircularProgress size={50} />
                </div>
            </Portal>}

            <Portal>
                <Dialog open={!!paymentFailedDialog} onClose={closePaymentFailedDialog} classes={{ paper: classes.dialogPaper }}>
                    <DialogTitle style={{ color: customTheme.palette.error.main }}><div style={{ fontSize: 16, textAlign: "center" }}>Payment Failed!</div></DialogTitle>
                    <DialogContent style={{ fontSize: 14, marginTop: 0, marginBottom: 10 }}>Description: {paymentFailedDialog}</DialogContent>
                    <DialogActions style={{ display: "flex", justifyContent: "space-evenly" }}>
                        <Button className={classes.dialogButton} variant="outlined" color="default" onClick={closePaymentFailedDialog}>Cancel</Button>
                        <Button disableElevation className={classes.dialogButton} variant="contained" color="secondary" onClick={rechargeWalletDigital}>Retry</Button>
                    </DialogActions>
                </Dialog>
            </Portal>
        </div>
    );
}

const AssignCard = (props) => {
    const classes = useStyles();
    const { record } = props
    //const notify = useNotify();
    const refresh = useRefresh();

    const [selectedOptions, setSelectedOptions] = useState("");

    const surfaceId = useRef("");
    const [open, setOpen] = React.useState(false);
    const [assignLoader, setAssignLoader] = useState(false);
    const [removeLoader, setRemoveLoader] = useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const assignHandler = () => {
        setAssignLoader(true);
        fetch(`${config.HOST_NAME}/crm/v3/assignOperatorWalletCard`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ serial_number: record.serial_number, access_key_id: record.access_key_id, surface_id: surfaceId.current, nfc_uid: selectedOptions }),
        })
            .then(response => {
                saveTokens(response)
                return response.json()
            })
            .then(json => {
                if (json.success) {
                    notify("Successfully Assigned", "success");
                    setOpen(false);
                    setAssignLoader(false);
                    setSelectedOptions("");
                    refresh();
                } else {
                    notify(json.message, "warning");
                    setAssignLoader(false);
                }
            })
            .catch((error) => {
                console.log(error);
                notify("Something went wrong", "warning");
                setAssignLoader(false);
            });

    };

    const removeHandler = () => {
        setRemoveLoader(true)
        fetch(`${config.HOST_NAME}/crm/v3/removeOperatorWalletCard`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ serial_number: record.serial_number, access_key_id: record.access_key_id }),
        })
            .then(response => {
                saveTokens(response)
                return response.json()
            })
            .then(json => {
                if (json.success) {
                    notify("Successfully Removed", "success");
                    setOpen(false);
                    setRemoveLoader(false);
                    refresh();
                } else {
                    notify(json.message, "warning");
                    setAssignLoader(false);
                }
            })
            .catch((error) => {
                console.log(error);
                notify("Something went wrong", "warning");
                setRemoveLoader(false);
            });
    };

    return (
        <div>
            <div>
                {record.nfc_uid == null && <Button variant="contained" color="primary" style={{ borderRadius: 100 }} onClick={handleClickOpen} disableElevation>Assign Card</Button>}
                {record.nfc_uid !== null && <div variant="contained" style={{ color: customTheme.palette.error.main, display: "flex", justifyContent: "start", alignItems: "start", flexDirection: "column", lineHeight: "0px", marginLeft: "15px", fontWeight: "bold" }}>
                    <p style={{ color: "#BDBDBD" }}>{record.surface_id}</p>
                    <p onClick={handleClickOpen} style={{ cursor: "pointer" }}>Remove Card</p>
                </div>}

                <Dialog
                    open={open}
                    onClose={handleClose}
                    fullWidth
                    classes={{ paper: classes.dialogPaper }}
                >
                    <div style={{ width: "100%" }}>
                        {record.nfc_uid == null && <SimpleForm style={{ padding: '0 22px' }} toolbar={false}>
                            <div style={{ width: "100%" }}>
                                <p style={{ fontSize: 15, fontWeight: "500", color: "black" }}>Select Card</p>
                                <RaAutocompleteInput
                                    source="search"
                                    resourceParam="search"
                                    filter={{ available: true }}
                                    customSort={["surface_id", "ASC"]}
                                    resourcePath="cardsInventory"
                                    label=""
                                    getOptionValue={(option) => {
                                        //setSurfaceId(option['surface_id'])
                                        surfaceId.current = option['surface_id']
                                        return option['nfc_uid']
                                    }}
                                    getOptionLabel={(option) =>
                                        `${option['surface_id']} - ${option['nfc_uid']}`
                                    }
                                    onSelect={(value) => setSelectedOptions(value)}
                                />
                            </div>
                        </SimpleForm>}

                        {record.nfc_uid !== null && <SimpleForm toolbar={false}>
                            <div style={{ paddingTop: "10px" }}>
                                <div style={{ display: "flex", flexDirection: "column" }}>
                                    <Box>
                                        <p style={{ fontSize: 15, fontWeight: "500", color: "black" }}>Are you sure you want to <strong>Remove</strong> this card.</p>
                                    </Box>
                                </div>
                            </div>
                        </SimpleForm>}
                    </div>

                    {record.nfc_uid == null && <DialogActions style={{ padding: "22px 35px" }}>
                        <Button onClick={handleClose} color="error" variant='contained' style={{ textTransform: "none", fontSize: 13, fontFamily: "Poppins-Regular", letterSpacing: "0.06em", height: "40px", minWidth: "120px", backgroundColor: "#E7EBF0", color: "#334D6E" }} disableElevation>
                            Cancel
                        </Button>
                        <Button onClick={assignHandler} color="primary" variant='contained' style={{ textTransform: "none", fontSize: 13, fontFamily: "Poppins-Regular", letterSpacing: "0.06em", height: "40px", minWidth: "120px", }} disableElevation>
                            Assign {assignLoader && <CircularProgress color="secondary" size={25} style={{ marginLeft: "10px" }} />}
                        </Button>
                    </DialogActions>}

                    {record.nfc_uid !== null && <DialogActions style={{ padding: "22px 35px" }}>
                        <Button onClick={handleClose} color="error" variant='contained' style={{ textTransform: "none", fontSize: 13, fontFamily: "Poppins-Regular", letterSpacing: "0.06em", height: "40px", minWidth: "120px", backgroundColor: "#E7EBF0", color: "#334D6E" }} disableElevation>
                            Cancel
                        </Button>
                        <Button onClick={removeHandler} color="contained" variant='contained' style={{ backgroundColor: customTheme.palette.error.main, color: "#FFF", textTransform: "none", fontSize: 13, fontFamily: "Poppins-Regular", letterSpacing: "0.06em", height: "40px", minWidth: "120px", }} autoFocus disableElevation>
                            Remove {removeLoader && <CircularProgress color="secondary" size={25} style={{ marginLeft: "10px" }} />}
                        </Button>
                    </DialogActions>}
                </Dialog>
            </div>
        </div>
    );
}
// const CustomDeviceInfoField = props => {
//     const { renderLocation } = props;
//     const record = useRecordContext(props);
//     const classes = useStyles();
//     const isSmallDevice = useMediaQuery(theme => customTheme.breakpoints.down("xs"));

//     const [loading, setLoading] = useState(true);
//     const [deviceInfo, setDeviceInfo] = useState(null);

//     useEffect(() => {

//         if (record && record.timestamp) {
//             setDeviceInfo({ last_seen: record.timestamp, battery: record.battery ? record.battery.split("%")[0] : "", power_source: record.power_source, location: { lat: record && record.gps ? record.gps.split(",")[0] : "", long: record && record.gps ? record.gps.split(",")[1] : "" } })
//             setLoading(false)
//         } else {
//             const token = sessionStorage.getItem('token');
//             fetch(`${config.HOST_NAME}/crm/v3/esperDevice?serial_number=${record["serial_number"]}`, {
//                 method: 'GET',
//                 headers: {
//                     'Content-Type': 'application/json',
//                     Authorization: `Bearer ${token}`
//                 },
//             })
//                 .then(response => response.json())
//                 .then(json => {
//                     setLoading(false);
//                     if (json.success) {
//                         setDeviceInfo(json.data);
//                     }
//                 })
//                 .catch((error) => {
//                     setLoading(false);
//                 });
//         }
//     }, []); // eslint-disable-line react-hooks/exhaustive-deps

//     return (isSmallDevice ?
//         loading ?
//             <div><LinearProgress /></div>
//             : (deviceInfo ?
//                 <div>
//                     <div>{renderStatus(deviceInfo, classes)}</div>
//                     {deviceInfo.battery ? <div><span style={{ color: "#5a5a5a" }}>Battery: </span>{deviceInfo.battery}%</div> : ""}
//                     {deviceInfo.power_source ? <div><span style={{ color: "#5a5a5a" }}>Power Source: </span>{deviceInfo.power_source}</div> : ""}
//                     {deviceInfo.location && !isNaN(deviceInfo.location.lat) ? renderLocation(deviceInfo) : ""}
//                 </div>
//                 : null)
//         :
//         loading ?
//             <>
//                 <td style={{ width: 100 }}><LinearProgress /></td>
//                 <td style={{ width: 100 }}><LinearProgress /></td>
//                 <td style={{ width: 100 }}><LinearProgress /></td>
//                 <td style={{ width: 100 }}><LinearProgress /></td>
//             </>
//             : (deviceInfo ?
//                 <>
//                     <td>{renderStatus(deviceInfo, classes)}</td>
//                     <td>{deviceInfo.battery ? <div>Battery: {deviceInfo.battery}%</div> : ""}</td>
//                     <td>{deviceInfo.power_source ? <div>Power Source: {deviceInfo.power_source}</div> : ""}</td>
//                     <td>{deviceInfo.location && !isNaN(deviceInfo.location.lat) ? renderLocation(deviceInfo, record) : ""}</td>
//                 </>
//                 : null)
//     );
// };

const validateDeviceCreation = (values) => {
    const errors = {};
    if (!values.serial_number || values.serial_number === "") {
        errors.serial_number = 'Serial Number is required';
    }
    if (!values.password || values.password === "") {
        errors.password = 'Password is required';
    }
    if (!values.access_key_id || values.access_key_id === "") {
        errors.access_key_id = 'Please select a parking';
    }
    return errors;
};

const valTypesDevice = [
    { id: 'ALL', name: 'ALL' },
    { id: 'ENTRY', name: 'ENTRY' },
    { id: 'EXIT', name: 'EXIT' },
]
export const CreateOperatorDevice = ({ ...props }) => {
    //const notify = useNotify();

    const [serialNumber, setSerialNumber] = useState("");
    const [password, setPassword] = useState("123456");
    const [accessKeyId, setAccessKeyId] = useState(null);
    const [digitalPaymentsEnabled, setDigitalPaymentsEnabled] = useState(false);
    const [loading, setLoading] = useState(false);
    const [dialogMessage, setDialogMessage] = useState(null);
    const [updating, setUpdating] = useState(false);

    const [deviceTypes, setDeviceTypes] = useState([]);
    const [deviceType, setDeviceType] = useState(undefined)

    const [createWithoutTerminal] = useState(sessionStorage.getItem("create_without_terminal") === "1")
    const [enableCreateWithoutTerminal, setEnableCreateWithoutTerminal] = useState(false);
    const captchaRef = React.useRef(null)

    const RECAPTCHA_KEY = '6Lemo3EhAAAAAC_QBTPnzeLpfPTPi0r5Mdr1tkEZ' //Production
    // const RECAPTCHA_KEY_ = '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI'//Development

    const redirect = useRedirect();
    const onSuccess = () => {
        notify("Element Created", "success")
        redirect(props.basePath)
    }
    const onFailure = (error) => {
        notify(error.message, "warning")
    }

    const verifyRecaptcha = async (token) => {
        return new Promise((resolve) => {
            fetch(`${config.HOST_NAME}/crm/v3/verifyRecaptcha?recaptcha_key=${RECAPTCHA_KEY}&token=${token}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                    'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
                },
            })
                .then(response => {
                    saveTokens(response)
                    return response.json()
                })
                .then((responseJson) => {
                    if (responseJson.success) {
                        resolve({ success: true })
                    } else resolve({ success: false, message: responseJson.message })
                })
                .catch((e) => {
                    console.log(e)
                    resolve({ success: false, message: 'Something Went Wrong' })
                });
        })
    }

    const saveOperatorDevice = async (event, toolbarProps) => {
        if (toolbarProps.invalid) {
            toolbarProps.handleSubmit(event);
            return;
        }
        setLoading(true);
        if (createWithoutTerminal && enableCreateWithoutTerminal) {
            const token = captchaRef.current.getValue();
            if (!token) {
                setLoading(false);
                return notify("Captcha Validation is Required", "error")
            };
            captchaRef.current.reset();
            const isReCaptchaVerified = await verifyRecaptcha(token)
            if (!isReCaptchaVerified.success) {
                setLoading(false);
                notify(isReCaptchaVerified.message, "error");
                return
            }
        }

        const params = {
            user_id: sessionStorage.getItem("user_id"),
            serial_number: serialNumber,
            password: password,
            access_key_id: accessKeyId,
            digital_payments_enabled: digitalPaymentsEnabled,
            device_type: deviceType === "ALL" ? "" : deviceType,
            create_without_terminal: createWithoutTerminal && enableCreateWithoutTerminal ? true : false
        };
        fetch(`${config.HOST_NAME}/crm/v3/operatorDevices`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
            },
            body: JSON.stringify(params),
        })
            .then(response => {
                saveTokens(response)
                return response.json()
            })
            .then((responseJson) => {
                setLoading(false);
                if (responseJson.success) {
                    notify(responseJson.message, "success");
                    props.history.push(props.basePath);
                } else if (responseJson.data?.serial_mapped) {
                    setDialogMessage(`This serial number is already mapped with ${responseJson.data.parking_name}. Do you want to replace it?`);
                } else {
                    notify(responseJson.message, 'warning');
                }
            })
            .catch((e) => {
                console.log(e)
                setLoading(false);
                notify('Error Saving Operator Device', 'warning')
            });
    };

    const closeDialog = () => {
        setDialogMessage(null);
    };

    const updateAccessKey = () => {
        setUpdating(true);
        const params = {
            user_id: sessionStorage.getItem("user_id"),
            serial_number: serialNumber,
            password: password,
            access_key_id: accessKeyId,
            digital_payments_enabled: digitalPaymentsEnabled,
        };
        fetch(`${config.HOST_NAME}/crm/v3/operatorDevices`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
            },
            body: JSON.stringify(params),
        })
            .then(response => {
                saveTokens(response)
                return response.json()
            })
            .then((responseJson) => {
                setUpdating(false);
                if (responseJson.success) {
                    closeDialog();
                    notify(responseJson.message, "info");
                    props.history.push(props.basePath);
                } else {
                    notify(responseJson.message, 'warning');
                }
            })
            .catch((e) => {
                setUpdating(false);
                notify('Error Updating Operator Device', 'warning')
            });
    };

    const CustomToolbar = toolbarProps => (
        <RaToolbar {...toolbarProps}>
            <Button variant="contained" color="primary" startIcon={loading ? <CircularProgress size={25} color="inherit" /> : <SaveIcon />} onClick={event => saveOperatorDevice(event, toolbarProps)} disabled={toolbarProps.pristine}>SAVE</Button>
        </RaToolbar>
    );

    useEffect(() => {
        setDeviceTypes(valTypesDevice)
        setDeviceType(valTypesDevice[0].id)
    }, [])

    return (<>
        <Create {...props} onFailure={onFailure} onSuccess={onSuccess} title="Add Operator Device">
            <SimpleForm validate={validateDeviceCreation} redirect="list" toolbar={<CustomToolbar />}>
                <TextInput variant="outlined" source="serial_number" label="Serial Number" onChange={event => setSerialNumber(event.target.value)} />
                <TextInput variant="outlined" source="password" label="Password" initialValue="123456" onChange={event => setPassword(event.target.value)} />
                <RaAutocompleteInput
                    source="access_key_id"
                    resourceParam="name"
                    resourcePath="uniqueParkingAccessKeys"
                    label="Parking"
                    getOptionValue={option => option["id"]}
                    getOptionLabel={option => option["name"]}
                    style={{ marginTop: 10, marginBottom: 20, maxWidth: 350 }}
                    onSelect={setAccessKeyId}
                />
                <div style={{ marginTop: 40 }}>
                    <SelectInput variant="outlined" label="Device Type" source="device_type" choices={deviceTypes} optionText="name" optionValue="id" defaultValue={deviceType} value={deviceType} onChange={event => setDeviceType(event.target.value)} style={{ display: "flex", position: "relative", top: -3 }} />
                </div>

                <div style={{ marginTop: 20 }}>
                    <Typography>Device Configurations</Typography>
                    <FormControlLabel control={<Checkbox checked={digitalPaymentsEnabled} />} label="Digital Payments" onChange={event => setDigitalPaymentsEnabled(event.target.checked)} />
                </div>
                {
                    createWithoutTerminal &&
                    <div>
                        <FormControlLabel control={<Checkbox checked={enableCreateWithoutTerminal} />} label="Create Without Terminal" onChange={event => setEnableCreateWithoutTerminal(event.target.checked)} />
                        <div style={{ display: 'flex', justifyContent: "flex-start", alignItems: "center", width: 400, color: "#BDBDBD", marginTop: -10, marginLeft: 30 }}>
                            <ErrorOutlineIcon fontSize="small" />
                            <p style={{ fontSize: 12, lineHeight: '3px', marginLeft: 5 }}>Please Create Device Without Terminal only when necessary</p>
                        </div>
                        {enableCreateWithoutTerminal && <div style={{ margin: '10px 0px 30px 0px' }}>
                            <RECAPTCHA
                                sitekey={RECAPTCHA_KEY}
                                ref={captchaRef}
                            />
                        </div>}
                    </div>
                }

            </SimpleForm>
        </Create>

        <Dialog open={dialogMessage != null} onClose={closeDialog}>
            <DialogContent>{dialogMessage}</DialogContent>
            <DialogActions>
                <Button onClick={closeDialog}>CANCEL</Button>
                <Button onClick={updateAccessKey} startIcon={updating && <CircularProgress size={25} />}>REPLACE</Button>
            </DialogActions>
        </Dialog>
    </>)
};

function OperatorDeviceDeleteButton(props) {
    //const notify = useNotify();
    const classes = useStyles();
    const refresh = useRefresh();

    const [dialogVisible, setDialogVisible] = React.useState(false);
    const [deleting, setDeleting] = React.useState(false);
    const [lastOperatorDevice, setLastOperatorDevice] = React.useState(false)

    const [transferWalletDetails, setTransferWalletDetails] = React.useState(null)
    const [selectedDevice, setSelectedDevice] = useState(null)
    const [walletId, setWalletId] = useState(null)
    const [selectedWalletAccessKeyId, setSelectedWalletAccessKeyId] = useState(null)


    const openDialog = () => {
        setDialogVisible(true);
    };

    const closeDialog = () => {
        setDialogVisible(false);
        setLastOperatorDevice(false)
        setTransferWalletDetails(null)
        setSelectedDevice(null)
        setWalletId(null)
        setSelectedWalletAccessKeyId(null)
        refresh();
    };

    const handleDelete = (event) => {
        event.preventDefault();
        const { record } = props;
        setDeleting(true);
        const params = {
            user_id: sessionStorage.getItem("user_id"),
            serial_number: record.serial_number,
        };
        fetch(`${config.HOST_NAME}/crm/v3/operatorDevices/${record.id}`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
            },
            body: JSON.stringify(params),
        })
            .then(response => {
                saveTokens(response)
                return response.json()
            })
            .then((responseJson) => {
                setDeleting(false);
                if (responseJson.success) {
                    if (responseJson.data?.transfer_wallet_balance) {
                        setTransferWalletDetails(responseJson.data)
                        return
                    }
                    if (responseJson.data?.last_operator_device) {
                        setLastOperatorDevice(true)
                        notify(responseJson.message, "success");
                    } else {
                        refresh();
                        notify(responseJson.message, "success");
                        setDialogVisible(false);
                    }
                } else {
                    notify(responseJson.message, 'warning');
                }
            })
            .catch((e) => {
                setDeleting(false);
                notify('Error Deleting Operator Device', 'warning')
            });
    };

    // It will delete the device & transfer the balance to other device
    const transferWalletBalanceHandler = () => {
        const { record } = props;
        if (transferWalletDetails.transfer_wallet_balance && !selectedDevice && transferWalletDetails.wallet_balance > 0) {
            notify('Please select a Device', 'warning');
            return
        }

        setDeleting(true);
        const params = {
            user_id: sessionStorage.getItem("user_id"),
            transfer_wallet_balance: true,
            selected_wallet_serial_number: selectedDevice,
            prev_serial_number_wallet_balance: transferWalletDetails.wallet_balance,
            wallet_id: walletId,
            selected_wallet_access_key_id: selectedWalletAccessKeyId
        };

        fetch(`${config.HOST_NAME}/crm/v3/deleteOperatorWithWalletBalance/${record.id}`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
            },
            body: JSON.stringify(params),
        })
            .then(response => {
                saveTokens(response)
                return response.json()
            })
            .then((responseJson) => {
                setDeleting(false);
                if (responseJson.success) {
                    closeDialog();
                    notify(responseJson.message, "success");
                    refresh()
                } else {
                    notify(responseJson.message, 'warning');
                }
            })
            .catch((e) => {
                setDeleting(false);
                notify('Error Updating Parking Terminal', 'warning')
            });
    };

    return (
        <>
            <RaButton onClick={openDialog} style={{ color: "#de575e" }} label={false} className={classes.deleteButton}>
                <DeleteIcon />
            </RaButton>
            {
                transferWalletDetails != null && transferWalletDetails.transfer_wallet_balance ?
                    <Dialog open={transferWalletDetails != null} onClose={closeDialog}>
                        <DialogContent>
                            <p>This serial number is already mapped with <strong>{transferWalletDetails.parking_name}</strong> and also have wallet balance of <strong>₹ {transferWalletDetails.wallet_balance}</strong>. Do you want to replace it?</p>
                            {transferWalletDetails.wallet_balance > 0 && <SimpleForm {...props} toolbar={false}>
                                <p>Please Select a Device to <strong>Transfer Wallet Balance</strong></p>
                                <RaAutocompleteInput
                                    source="serial_number"
                                    resourceParam="serial_number"
                                    resourcePath="operatorWallets"
                                    filter={{ available: true }}
                                    label=""
                                    getOptionValue={(option) => {
                                        setWalletId(option['id'])
                                        setSelectedWalletAccessKeyId(option['access_key_id'])
                                        return option['serial_number']
                                    }}
                                    getOptionLabel={(option) => `${option['serial_number']}`}
                                    useAccessKeyId={true}
                                    accessKeyIdValue={transferWalletDetails.wallet_access_key_id}
                                    onSelect={(value) => setSelectedDevice(value)}
                                    style={{ marginBottom: "20px" }}
                                />
                            </SimpleForm>}
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={closeDialog} color="default">Close</Button>
                            <Button onClick={transferWalletBalanceHandler} className={classes.deleteButton}>Delete {deleting && <CircularProgress size={20} />}</Button>
                        </DialogActions>
                    </Dialog>
                    :
                    <Dialog fullWidth open={dialogVisible} onClose={closeDialog}>
                        <DialogContent>
                            {lastOperatorDevice ? <p>This is the <strong>Last Operator Device</strong>. It is recommended that you also <strong>Delete</strong> this Device from <strong>Parking Terminal</strong>.</p>
                                : <p>Are you sure you want to <strong>Delete</strong> this device.</p>}
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={closeDialog} color="default">{!lastOperatorDevice ? "Cancel" : "Close"}</Button>
                            {!lastOperatorDevice && <Button onClick={handleDelete} className={classes.deleteButton}>Delete {deleting && <CircularProgress size={20} />}</Button>}
                        </DialogActions>
                    </Dialog>

            }

        </>
    );
}

const DeleteDeviceButton = compose(
    connect(
        null,
        { dispatchCrudDelete: crudDelete }
    ),
    translate
)(OperatorDeviceDeleteButton);

export const EditOperatorDevice = ({ ...props }) => {
    const redirect = useRedirect();
    const onSuccess = () => {
        notify("Element Updated", "success")
        redirect(props.basePath)
    }
    const onFailure = (error) => {
        notify(error.message, "warning")
    }
    return (
        <Edit {...props} onFailure={onFailure} onSuccess={onSuccess} undoable={false} title='Edit Operator Devices'>
            <SimpleForm redirect="list" toolbar={<CustomEditToolbar />}>
                <CustomEditForm />
            </SimpleForm>
        </Edit>
    )
}

const CustomEditToolbar = withStyles(toolbarStyles)(props => (
    <RaToolbar {...props}>
        <SaveButton style={{ backgroundColor: "#18cc69", marginTop: 13, width: "120px", borderRadius: 5 }} disableElevation />
    </RaToolbar>
));

const CustomEditForm = (props) => {

    const { input: { value: password, onChange: setPassword } } = useInput({ ...props, id: "password", source: "password" });
    const { input: { value: digitalPaymentsEnabled, onChange: setDigitalPaymentsEnabled } } = useInput({ ...props, id: "digital_payments_enabled", source: "digital_payments_enabled" });
    const { input: { value: deviceType, onChange: setDeviceType } } = useInput({ ...props, id: "device_type", source: "device_type" });
    const [showPassword, setShowPassword] = useState(false);
    const [deviceTypes, setDeviceTypes] = useState([]);

    useEffect(() => {
        setDeviceTypes(valTypesDevice)
    }, [])

    return <>

        <div style={{ margin: "30px 0 20px" }}>
            <MuiTextField
                className='changePasswordTextField'
                type={showPassword ? "text" : "password"}
                variant="outlined"
                size="small"
                label="New Password"
                value={password}
                onChange={event => setPassword(event.target.value)}
                style={{ display: "block", marginBottom: 20 }}
                InputProps={{
                    endAdornment: <InputAdornment position="end">
                        <IconButton
                            onClick={() => setShowPassword(!showPassword)}
                            edge="end"
                        >
                            {showPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
                        </IconButton>
                    </InputAdornment>
                }}
            />

            <div style={{ width: 250 }}>
                <SelectInput variant="outlined" label="Device Type" source="device_type" choices={deviceTypes} optionText="name" optionValue="id" defaultValue={deviceType} value={deviceType} onChange={event => setDeviceType(event.target.value)} style={{ display: "flex", position: "relative", top: -3 }} />
            </div>
            <Typography>Device Configurations</Typography>
            <FormControlLabel control={<Checkbox checked={digitalPaymentsEnabled === 1 ? true : false} />} label="Digital Payments" onChange={event => setDigitalPaymentsEnabled(event.target.checked === true ? 1 : 0)} />
        </div>

    </>

}

const CustomModal = ({ displayModal, setDisplayModal, data }) => {

    const classes = useStyles();
    const isSmallDevice = useMediaQuery(theme => customTheme.breakpoints.down("xs"));
    const [loading, setLoading] = useState(true)
    const [lastLogins, setLastLogins] = useState(null)

    const fetchLastLogins = () => {
        setLoading(true)
        fetch(`${config.HOST_NAME}/crm/v3/getOperatorDevicesLastLogins?serial_number=${data.serial_number}`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
            },
        }).then(response => {
            saveTokens(response)
            return response.json();
        }).then((responseJson) => {
            setLoading(false);
            if (responseJson.success) {
                setLastLogins(responseJson.data);
            } else {
                notify(responseJson.message, 'warning');
            }
        })
        .catch((e) => {
            setLoading(false);
            notify('Something went wrong', 'warning');
        });
    }

    useEffect(() => {
        fetchLastLogins()
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <div>
            <div className={`CustomModal ${displayModal ? "Show" : ""}`} style={{ width: isSmallDevice ? "100%" : "400px" }}>
                <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: "center" }}>
                    <IconButton
                        onClick={() => setDisplayModal(!displayModal)}
                    >
                        <ArrowBackIcon />
                    </IconButton>
                    <p style={{ fontSize: 14, fontWeight: "bold", marginLeft: 10 }}>{data.serial_number}</p>
                </div>
                <div className='siteAuditsScroll' style={{ overflow: "auto", overflowX: "hidden", height: "calc(100vh - 50px)" }}>
                    {!loading && lastLogins &&
                        <MuiList component="nav"
                            aria-labelledby="nested-list-subheader"
                            className={classes.root}
                            subheader={<ListSubheader component="div" id="nested-list-subheader" style={{ backgroundColor: "white" }}>Last Logins</ListSubheader>}
                        >
                            {lastLogins.map((value) => (
                                <ListItem>
                                    <ListItemText primary={value.parking_name} secondary={moment(value.time_stamp).format('lll')} />
                                </ListItem>
                            ))}
                        </MuiList>
                    }
                    {loading &&
                        <div style={{ position: 'absolute', left: 0, right: 0, marginLeft: 'auto', marginRight: 'auto', width: '100px' }}>
                            <CircularProgress />
                        </div>
                    }
                    {!loading && (!lastLogins || lastLogins.length === 0) && <p style={{ padding: 5, textAlign: "center" }}>No logins found.</p>}
                </div>
            </div>
            <div
                className={`CustomOverlay ${displayModal ? "Show" : ""}`}
                onClick={() => setDisplayModal(!displayModal)}
            />
        </div >
    )
}

/* Operator Shifts */
const SHIFT_COLUMNS = {
    "Parking Name": false,
};
// const renderDate = datetime => moment(datetime).format("DD/MM/YYYY hh:mm A");
const StatusIndicator = ({ record }) => {
    const classes = useStyles();

    if (typeof record["shift_end"] === "string" && record["shift_end"] !== "")
        return <><span className={classes.statusIndicator} style={{ backgroundColor: customTheme.palette.primary.main }} /> Completed</>;
    else
        return <><span className={classes.statusIndicator} style={{ backgroundColor: "#f7bf05" }} /> Ongoing</>;
};
export function OperatorShiftsList(props) {
    const classes = useStyles();
    const location = useLocation()
    const isSmallDevice = useMediaQuery(theme => customTheme.breakpoints.down("xs"));
    const listDataRef = useRef();
    const [showFilter] = useState(sessionStorage.getItem("show_filter") === "1");
    let prevSearch = sessionStorage.getItem(location.pathname) ? JSON.parse(sessionStorage.getItem(location.pathname)) : ""
    const [startDateTime, setStartDateTime] = useState(null);
    const [endDateTime, setEndDateTime] = useState(null);
    const [displayColumns, setDisplayColumns] = useState(localStorage.getItem("operatorShiftColumns") ? JSON.parse(localStorage.getItem("operatorShiftColumns")) : SHIFT_COLUMNS);
    const [currentParking, setCurrentParking] = useState(prevSearch.currentParking ? prevSearch.currentParking : {});
    const zoneIds = currentParking.zone_ids ? currentParking.zone_ids.split(",") : null;
    const zoneLabels = currentParking.zones ? currentParking.zones.split(";") : null;
    const finalZones = zoneIds && zoneLabels ? zoneIds.map((id, index) => (
        { id, name: zoneLabels[index] }
    )) : null;
    if (finalZones)
        finalZones.sort((a, b) => (a.name > b.name ? 1 : (a.name < b.name ? -1 : 0)));

    const [filterListValue, setFilterListValue] = useState(prevSearch.radioValue ? prevSearch.radioValue : null)
    let filterTypesInitState = [
        {
            resourcePath: "getParkingTerminals",
            filterType: "Search Devices",
            filterParams: {
				access_key: currentParking.id,
				parking_info_id: currentParking.allZones ? currentParking.parking_info_id : null,
			},
            dataList: [],
            searchList: [],
            listType: "Dynamic",
            resourceParam: "search_by_serial_number",
            source: "search_by_serial_number",
            valueKey: "serial_number",
            showFilter: true
        },
        {
            resourcePath: "operator/users",
            filterType: "Search Operator",
            filterParams: {
				access_key: currentParking.allZones ? 'All' : currentParking.id,
				parking_info_id: currentParking.allZones ? currentParking.parking_info_id : null,
			},
            dataList: [],
            searchList: [],
            listType: "Dynamic",
            resourceParam: "operator",
            source: "operator",
            responseSource: "operator",
            valueKey: "operator",
            showFilter: true
        },
        {
            filterType: "Display Columns",
            dataList: { "Parking Name": false, "RFID": false },
            listType: "CheckboxStatic",
            caseType: "CheckboxTypeStatic",
            showFilter: true,
            filterFormat: "Checkbox"
        },
    ]
    const [use24HourFormat] = useState(sessionStorage.getItem("use_24_hour_format") === "1");
	const [showTimeTillSeconds] = useState(sessionStorage.getItem("show_time_till_seconds") === "1");

	const renderTime = time => {
		const secondsFormat = showTimeTillSeconds ? ":ss" : "";
        if(use24HourFormat) return moment(time, "YYYY-MM-DD HH:mm:ss").format(`DD/MM/YYYY HH:mm${secondsFormat}`)
        return moment(time, "YYYY-MM-DD HH:mm:ss").format(`DD/MM/YYYY hh:mm${secondsFormat} A`)
	};
    const [settingFilterFormat, setSettingFilterFormat] = useState({})

    const filter = { ...settingFilterFormat, start_time: startDateTime ? moment(startDateTime).format("YYYY-MM-DD HH:mm:ss") : "", end_time: endDateTime ? moment(endDateTime).format("YYYY-MM-DD HH:mm:ss") : "", access_key: currentParking.id, parking_info_id: currentParking.allZones ? currentParking.parking_info_id : undefined };

    const onParkingChange = (parking) => {
        setCurrentParking({ ...parking, allZones: true });
    };

    const onZoneChange = (event) => {
        setCurrentParking({
            ...currentParking,
            id: event.target.value,
            name: zoneLabels[zoneIds.findIndex(id => id === event.target.value)],
            allZones: event.target.value === "All"
        });
    };

    useEffect(() => {
        let values = {}
        // Add more types based on the filters
        if (filterListValue) {
            for (let val in filterListValue) {
                if (filterListValue[val].filterType === "Search Operator") {
                    values = { ...values, operator: filterListValue[val].value ? filterListValue[val].value : undefined }
                }
                if (filterListValue[val].filterType === "Search Devices") {
                    values = { ...values, serial_number: filterListValue[val].value ? filterListValue[val].value : undefined }
                }
            }
            setSettingFilterFormat(values)
        }
        if (filterListValue === null) {
            setSettingFilterFormat({})
        }
    }, [filterListValue]) // eslint-disable-line react-hooks/exhaustive-deps

    return <div className={classes.list}>
        <div className={classes.parkingSelectorContainer} style={{ gridAutoFlow: isSmallDevice ? "row" : "column", gridTemplateColumns: isSmallDevice ? "100%" : "48% 48%", gridRowGap: isSmallDevice ? 18 : 0, margin: 0 }}>
            {showFilter &&
                <ParkingSearchSelector
                    value={currentParking}
                    onChange={onParkingChange}
                    clearable={true}
                    pathName={location.pathname}
                />
            }
            {currentParking.zone_ids && currentParking.zone_ids.includes(',') &&
                <FormControl variant="outlined" style={{ marginTop: isSmallDevice ? 0 : 10 }}>
                    <InputLabel>Zone Name</InputLabel>
                    <Select
                        value={currentParking.allZones ? "All" : currentParking.id}
                        onChange={onZoneChange}
                        label="Zone Name"
                        variant="outlined"
                    >
                        <MenuItem value="All">All</MenuItem>
                        {finalZones.map((zone, index) => (
                            <MenuItem key={index} value={zone.id}>{zone.name}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
            }
        </div>

        <div className='customStyleForDataSearchDiv'>
            <CustomDateTimePicker startDateTime={startDateTime} setStartDateTime={setStartDateTime} endDateTime={endDateTime} setEndDateTime={setEndDateTime} />
            <CustomFilter filterTypesInitState={filterTypesInitState} filterListValue={filterListValue} setFilterListValue={setFilterListValue} pathName={location.pathname} defaultColumns={SHIFT_COLUMNS} storageKey="operatorShiftColumns" displayColumns={displayColumns} setDisplayColumns={setDisplayColumns} />
        </div>
        <ShowTimePeriod startDateTimeFilter={startDateTime} endDateTimeFilter={endDateTime}/>
        <List
            {...props}
            style={{marginTop: 20}}
            title="Operator Shifts"
            bulkActionButtons={false}
            sort={{ field: "shift_start", order: "DESC" }}
            exporter={false}
            filter={filter}
            empty={false}
            actions={false}
            pagination={<CustomPagination setListData={(listData) => {listDataRef.current = listData}} />}
        >
            {isSmallDevice ?
                <SimpleList
                    primaryText={record => record["operator"]}
                    secondaryText={record => (<div>
                        {displayColumns["Parking Name"] && <div style={{ color: customTheme.palette.secondary.main }}>{record["parking_name"] ? `Parking Name: ${record["parking_name"]}` : ""}</div>}
                        <div>{record["shift_start"] ? `Shift Start: ${record["shift_start"]}` : ""}</div>
                        <div>{record["shift_end"] ? `Shift End: ${record["shift_end"]}` : ""}</div>
                        <div>Status: <StatusIndicator record={record} /></div>
                        <div>Duration: {moment(typeof record["shift_end"] === "string" && record["shift_end"] !== "" ? record["shift_end"] : undefined).to(record["shift_start"], true)}</div>
                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                            <div>Device ID: {record["unique_user_id"] === "string" && record["unique_user_id"] !== "" ? record["unique_user_id"] : record["serial_number"]}</div>
                            <ShiftExportButton {...props} record={record} />
                        </div>
                    </div>)}
                    onContextMenu={event => event.preventDefault()}
                    linkType={false}
                    rowStyle={() => ({ alignItems: "flex-start", borderBottom: "1px solid #18cc69" })}
                />
                :
                <Datagrid rowClick="expand" expand={<ShiftDetails />} component={ScrollableTable}>
                    <TextField source="operator" label="Operator Name" />
                    <FunctionField source="shift_start" label="Start Time" render={record => renderTime(record["shift_start"])} sortable />
                    <FunctionField source="shift_end" label="End Time" render={record => record["shift_end"] !== "" ? renderTime(record["shift_end"]) : "-"} sortable />
                    <FunctionField label="Status" render={record => <StatusIndicator record={record} />} />
                    <FunctionField label="Duration" render={record => moment(typeof record["shift_end"] === "string" && record["shift_end"] !== "" ? record["shift_end"] : undefined).to(record["shift_start"], true)} />
                    <FunctionField source="unique_user_id" label="Device ID" sortable={true} render={record => typeof record["unique_user_id"] === "string" && record["unique_user_id"] !== "" ? record["unique_user_id"] : record["serial_number"]} />
                    {displayColumns["Parking Name"] && <TextField source="parking_name" label="Parking" />}
                    <ShiftExportButton />
                </Datagrid>
            }

        </List>
    </div>
}

function ShiftExportButton(props) {
    const { record } = props;
    //const notify = useNotify();

    const getExportFile = (fileType) => {
        fetch(`${config.HOST_NAME}/crm/v3/operator/shifts/${record.id}/details`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
                'Content-Type': 'application/json',
                'Accept': `application/${fileType}`
            }
        })
            .then(response => {
                saveTokens(response)
                return response.blob()
            })
            .then(blob => {
                const url = URL.createObjectURL(blob);
                const tempLinkElement = document.createElement('a');
                tempLinkElement.href = url;
                tempLinkElement.setAttribute("download", `${moment(record["shift_start"]).format("Do MMM YYYY (h:mm A)")} - ${typeof record["unique_user_id"] === "string" && record["unique_user_id"] !== "" ? record["unique_user_id"] : record["serial_number"]} - ${record["operator"]}.${fileType}`);
                tempLinkElement.click();
            })
            .catch(error => {
                notify('Error Exporting Data', 'warning');
            });
    };

    const getExcelFile = () => {
        getExportFile("xlsx");
    };

    const getPDF = () => {
        getExportFile("pdf");
    };

    if (!record) return null;
    return (
        <CustomExportButton getCSV={getExcelFile} getPDF={getPDF} />
    );
}

const ShiftDetailsSkeleton1 = props => <Skeleton variant="text" height={18} width={160} style={{ display: "inline-block", transform: "none" }} {...props} />;
const ShiftDetailsSkeleton2 = props => <Skeleton variant="text" height={30} width={110} style={{ display: "inline-block", transform: "none" }} {...props} />;
const StyledTableCell = withStyles((theme) => ({
    root: {
        fontSize: 13,
        borderBottomColor: customTheme.palette.divider,
        padding: "15px 5px !important",
    },
    head: {
        fontWeight: 500,
        color: customTheme.palette.grey[700],
    },
    body: {
        fontWeight: 400,
        color: customTheme.palette.grey[500],
    },
}))(TableCell);
const CATEGORIES = {
    PAID: "Paid",
    FOC: "FOC",
    IDF: "Drop Off"
};
const paymentModeColors = {
    "CASH": "#e99100",
    "Smart Pass": "#16cc69",
    "CARD": "#109cf1",
    "UPI": "#885af8",
    "FASTag": "#f7685b",
};
const createSortable = (order, orderBy) => (a, b) => {
    const summaryColumns = {
        "Vehicle Number": "license_number",
        "Type": "vehicle_type",
        "Entry Time": "entry_time",
        "Exit Time": "exit_time",
        "Total Amount": "amount",
        "Payment Type": "mode_of_payment",
        "Category": "category",
        "Entry User": "entry_user_id",
        "Exit User": "exit_user_id",
    };

    const priority1 = orderBy !== "Exit Time" ? summaryColumns[orderBy] : "exit_time";
    const priority2 = orderBy !== "Exit Time" ? "exit_time" : "entry_time";
    const higherValue = order === "asc" ? 1 : -1;
    const lowerValue = order === "asc" ? -1 : 1;
    if (a[priority1] && b[priority1]) {
        if (a[priority1] > b[priority1]) {
            return higherValue;
        }
        if (a[priority1] < b[priority1]) {
            return lowerValue;
        }
    }
    if (a[priority1]) {
        return higherValue;
    }
    if (b[priority1]) {
        return lowerValue;
    }
    if (a[priority2] > b[priority2]) {
        return higherValue;
    }
    if (a[priority2] < b[priority2]) {
        return lowerValue;
    }
    return 0;
};
function ShiftDetails(props) {
    const { record } = useShowController(props);
    //const notify = useNotify();
    const classes = useStyles();

    const [details, setDetails] = useState(null);
    const [allVehicles, setAllVehicles] = useState(null);
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(25);
    const [order, setOrder] = React.useState("desc");
    const [orderBy, setOrderBy] = React.useState("Exit Time");
    const [use24HourFormat] = useState(sessionStorage.getItem("use_24_hour_format") === "1");
	const [showTimeTillSeconds] = useState(sessionStorage.getItem("show_time_till_seconds") === "1");

	const renderTime = time => {
		const secondsFormat = showTimeTillSeconds ? ":ss" : "";
        if(use24HourFormat) return moment(time, "YYYY-MM-DD HH:mm:ss").format(`DD/MM/YYYY HH:mm${secondsFormat}`)
        return moment(time, "YYYY-MM-DD HH:mm:ss").format(`DD/MM/YYYY hh:mm${secondsFormat} A`)
	};

    let visibleRows = null;
    if (allVehicles)
        visibleRows = allVehicles.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleRequestSort = (property) => {
        const isAsc = orderBy === property && order === 'asc';
        let tempOrder = isAsc ? 'desc' : 'asc';
        setOrder(tempOrder);
        setOrderBy(property);

        const tempVehicles = allVehicles;
        tempVehicles.sort(createSortable(tempOrder, property));
        setAllVehicles(tempVehicles);
    };

    useEffect(() => {
        if (record) {
            fetch(`${config.HOST_NAME}/crm/v3/operator/shifts/${record.id}/details`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                    'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
                }
            })
                .then(response => {
                    saveTokens(response)
                    return response.json()
                })
                .then(json => {
                    if (json.success) {
                        let { all_vehicles: tempVehicles, ...restData } = json.data;
                        setDetails(restData);

                        tempVehicles = tempVehicles.map(row => {
                            let category = null;
                            if (row.free_vehicle === true || row.free_vehicle === 1 || row.free_vehicle === "true")
                                category = CATEGORIES.FOC;
                            else if (row.exit_time && row.exit_user_id !== "CLEARED") {
                                if (!((row.amount_at_entry && parseFloat(row.amount_at_entry) > 0) || (row.amount_at_exit && parseFloat(row.amount_at_exit) > 0)))
                                    category = CATEGORIES.IDF;
                                else
                                    category = CATEGORIES.PAID;
                            }
                            return {
                                ...row,
                                category
                            };
                        });
                        tempVehicles.sort(createSortable(order, orderBy));
                        setAllVehicles(tempVehicles);
                    } else {
                        notify(json.message, "warning");
                    }
                }).catch((e) => {
                    notify('Could not fetch shift details', 'warning');
                });
        }
    }, [record]); // eslint-disable-line react-hooks/exhaustive-deps

    if (!record) return null;
    return (
        <div>
            <div className="summaryContainer" style={{ display: "flex", justifyContent: "space-between", columnGap: 20 }}>
                <div className={classes.summaryBox}>
                    <Typography className="summaryBoxLabel2">Vehicle In</Typography>
                    {details ? <Typography className="summaryBoxValue2">{details.entry_count}</Typography> : <ShiftDetailsSkeleton2 />}

                    <div style={{ marginTop: 20 }}>
                        {details ?
                            Object.keys(details.vehicleTypes).map(type => (
                                <div key={type} style={{ display: "flex", alignItems: "center", marginTop: 4 }}>
                                    <img className="summaryVehicleIcon" src={vehicleSvgs[type]} alt={details.vehicleTypes[type].label} />
                                    <Typography className="summaryBoxLabel1" style={{ marginRight: 8 }}>{details.vehicleTypes[type].label}:</Typography>
                                    <Typography className="summaryBoxValue1">{details.vehicleTypes[type].entry_count}</Typography>
                                </div>
                            ))
                            :
                            ["60%", "55%", "70%"].map((width, index) => (
                                <div style={{ marginTop: 4 }}><ShiftDetailsSkeleton1 width={width} /></div>
                            ))
                        }
                    </div>
                </div>

                <div className={classes.summaryBox}>
                    <Typography className="summaryBoxLabel2">Vehicle Out</Typography>
                    {details ? <Typography className="summaryBoxValue2">{details.exit_count}</Typography> : <ShiftDetailsSkeleton2 />}

                    <div style={{ marginTop: 20 }}>
                        {details ?
                            Object.keys(details.vehicleTypes).map(type => (
                                <div key={type} style={{ display: "flex", alignItems: "center", marginTop: 4 }}>
                                    <img className="summaryVehicleIcon" src={vehicleSvgs[type]} alt={details.vehicleTypes[type].label} />
                                    <Typography className="summaryBoxLabel1" style={{ marginRight: 8 }}>{details.vehicleTypes[type].label}:</Typography>
                                    <Typography className="summaryBoxValue1">{details.vehicleTypes[type].exit_count}</Typography>
                                </div>
                            ))
                            :
                            ["60%", "55%", "70%"].map((width, index) => (
                                <div style={{ marginTop: 4 }}><ShiftDetailsSkeleton1 width={width} /></div>
                            ))
                        }
                    </div>
                </div>

                <div className={classes.summaryBox}>
                    <Typography className="summaryBoxLabel2">Collection</Typography>
                    {details ? <Typography className="summaryBoxValue2">₹ {details.amount}</Typography> : <ShiftDetailsSkeleton2 />}
                    {details && <div style={{ display: "grid", gridTemplateColumns: "50% 50%", alignItems: "center" }}>
                        <div style={{ display: "flex", alignItems: "center" }}>
                            <Typography className="summaryBoxLabel3" style={{ marginRight: 8 }}>Cash:</Typography>
                            <Typography className="summaryBoxValue3">₹ {details.cash_amount}</Typography>
                        </div>
                        <div style={{ display: "flex", alignItems: "center" }}>
                            <Typography className="summaryBoxLabel3" style={{ marginRight: 8 }}>Digital:</Typography>
                            <Typography className="summaryBoxValue3">₹ {details.digital_amount}</Typography>
                        </div>
                    </div>}

                    <div style={{ marginTop: 20 }}>
                        {details ?
                            Object.keys(details.vehicleTypes).map(type => (<>
                                <div key={type} style={{ display: "flex", alignItems: "center", marginTop: 4 }}>
                                    <img className="summaryVehicleIcon" src={vehicleSvgs[type]} alt={details.vehicleTypes[type].label} />
                                    <Typography className="summaryBoxLabel1" style={{ marginRight: 8 }}>{details.vehicleTypes[type].label}:</Typography>
                                    <Typography className="summaryBoxValue1">₹ {details.vehicleTypes[type].amount}</Typography>
                                </div>

                                <div style={{ display: "grid", gridTemplateColumns: "50% 50%", alignItems: "center", marginLeft: 24 }}>
                                    <div style={{ display: "flex", alignItems: "center" }}>
                                        <Typography className="summaryBoxLabel3" style={{ marginRight: 8 }}>Cash:</Typography>
                                        <Typography className="summaryBoxValue3">₹ {details.vehicleTypes[type].cash_amount}</Typography>
                                    </div>
                                    <div style={{ display: "flex", alignItems: "center" }}>
                                        <Typography className="summaryBoxLabel3" style={{ marginRight: 8 }}>Digital:</Typography>
                                        <Typography className="summaryBoxValue3">₹ {details.vehicleTypes[type].digital_amount}</Typography>
                                    </div>
                                </div>
                            </>))
                            :
                            ["60%", "55%", "70%"].map((width, index) => (
                                <div style={{ marginTop: 4 }}><ShiftDetailsSkeleton1 width={width} /></div>
                            ))
                        }
                    </div>
                </div>
            </div>

            <Paper style={{ width: "100%", mb: 2, boxShadow: "none", padding: "0 1px", border: "1px solid #bfbfbf", borderRadius: 10, marginTop: 20 }}>
                <TableContainer component={Paper} style={{ boxShadow: "none", padding: 0, maxHeight: 300 }}>
                    <Table stickyHeader size="small" style={{ padding: 0 }} className="tableRow-padding-3">
                        <TableHead>
                            <TableRow>
                                {["Vehicle Number", "Type", "Entry Time", "Exit Time", "Total Amount", "Payment Type", "Category", "Entry User", "Exit User", "Remarks"].map(column => !["Remarks"].includes(column) ?
                                    <StyledTableCell key={column} sortDirection={orderBy === column ? order : false}>
                                        <TableSortLabel
                                            active={orderBy === column}
                                            direction={orderBy === column ? order : 'asc'}
                                            onClick={() => handleRequestSort(column)}
                                        >
                                            {column}
                                        </TableSortLabel>
                                    </StyledTableCell>
                                    :
                                    <StyledTableCell key={column}>{column}</StyledTableCell>

                                )}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {visibleRows ?
                                visibleRows.map((row, index) => (<TableRow key={row["id"]}>
                                    <StyledTableCell component="th" scope="row" className={classes.mainTableCell}>{row["license_number"]}</StyledTableCell>
                                    <StyledTableCell><img className={classes.listVehicleIcon} src={vehicleSvgs[row.vehicle_type]} alt={details.vehicleTypes[row.vehicle_type].label} title={details.vehicleTypes[row.vehicle_type].label} /></StyledTableCell>
                                    <StyledTableCell>{renderTime(row.entry_time)}</StyledTableCell>
                                    <StyledTableCell>{row.exit_time && row.exit_user_id !== "CLEARED" ? renderTime(row.exit_time) : "-"}</StyledTableCell>
                                    <StyledTableCell>{row.amount != null && row.amount !== "" ? `₹${parseFloat(parseFloat(row.amount))}` : "-"}</StyledTableCell>
                                    <StyledTableCell>
                                        <div
                                            className={classes.chipCell}
                                            style={paymentModeColors[row.mode_of_payment] ? { color: paymentModeColors[row.mode_of_payment], backgroundColor: (paymentModeColors[row.mode_of_payment] + "19") } : { color: "#555555", backgroundColor: "#55555519" }}
                                        >
                                            {row.mode_of_payment}
                                        </div>
                                    </StyledTableCell>
                                    <StyledTableCell style={{ textAlign: "center" }}>
                                        {row.category ? <div
                                            className={classes.chipCell}
                                            style={{ color: customTheme.palette.secondary.main, backgroundColor: customTheme.palette.secondary.main + "20" }}
                                        >
                                            {row.category}
                                        </div> : ""}
                                        {[true, 1, "true", "1"].includes(row.lost_ticket) ? <div style={{ marginTop: 4, fontSize: 13, color: "#777" }}>Lost Ticket</div> : null}
                                    </StyledTableCell>
                                    <StyledTableCell style={{ textAlign: "center" }}><div style={{ color: "#727272" }}>{row.entry_user_id}</div>{row.entry_device_id && <div style={{ marginTop: 1 }}>{row.entry_device_id}</div>}</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: "center" }}>{row.exit_user_id !== "CLEARED" ? <><div style={{ color: "#727272" }}>{row.exit_user_id}</div>{row.exit_device_id && <div style={{ marginTop: 1 }}>{row.exit_device_id}</div>}</> : "-"}</StyledTableCell>
                                    <StyledTableCell>{row.remarks}</StyledTableCell>
                                </TableRow>))
                                :
                                [1, 2, 3].map((row) => (<TableRow key={row}>
                                    <StyledTableCell component="th" scope="row" className={classes.mainTableCell}><ShiftDetailsSkeleton1 width={100} /></StyledTableCell>
                                    <StyledTableCell><ShiftDetailsSkeleton1 width={50} /></StyledTableCell>
                                    <StyledTableCell><ShiftDetailsSkeleton1 width={110} /></StyledTableCell>
                                    <StyledTableCell><ShiftDetailsSkeleton1 width={110} /></StyledTableCell>
                                    <StyledTableCell><ShiftDetailsSkeleton1 width={65} /></StyledTableCell>
                                    <StyledTableCell style={{ textAlign: "center" }}><ShiftDetailsSkeleton1 width={80} /></StyledTableCell>
                                    <StyledTableCell style={{ textAlign: "center" }}><ShiftDetailsSkeleton1 width={80} /></StyledTableCell>
                                    <StyledTableCell style={{ textAlign: "center" }}><ShiftDetailsSkeleton1 width={90} /></StyledTableCell>
                                    <StyledTableCell style={{ textAlign: "center" }}><ShiftDetailsSkeleton1 width={90} /></StyledTableCell>
                                    <StyledTableCell><ShiftDetailsSkeleton1 width={75} /></StyledTableCell>
                                </TableRow>))
                            }
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[25, 50, 100]}
                    count={allVehicles ? allVehicles.length : 0}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onChangePage={handleChangePage}
                    onChangeRowsPerPage={handleChangeRowsPerPage}
                />
            </Paper>
        </div>
    );
}

const AntSwitch = withStyles((theme) => ({
    root: {
        width: 29,
        height: 16,
        padding: 0,
        display: 'flex',
    },
    switchBase: {
        padding: 2,
        color: theme.palette.grey[500],
        '&$checked': {
            transform: 'translateX(12px)',
            color: theme.palette.common.white,
            '& + $track': {
                opacity: 1,
                backgroundColor: theme.palette.primary.main,
                borderColor: theme.palette.primary.main,
            },
        },
    },
    thumb: {
        width: 12,
        height: 12,
        boxShadow: 'none',
    },
    track: {
        border: `1px solid ${theme.palette.grey[500]}`,
        borderRadius: 16 / 2,
        opacity: 1,
        backgroundColor: theme.palette.common.white,
        height: "auto",
        paddingTop: 2,
        paddingBottom: 2
    },
    checked: {},
}))(Switch);